/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AcceptIntroInput
 */
export interface AcceptIntroInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof AcceptIntroInput
     */
    'id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof AcceptIntroInput
     */
    'user_id': string;
}
/**
 * 
 * @export
 * @interface AcceptorIntroductionState
 */
export interface AcceptorIntroductionState {
    /**
     * 
     * @type {string}
     * @memberof AcceptorIntroductionState
     */
    'AWAITING_INTRODUCER'?: string;
    /**
     * 
     * @type {string}
     * @memberof AcceptorIntroductionState
     */
    'AWAITING_REQUESTOR'?: string;
    /**
     * 
     * @type {string}
     * @memberof AcceptorIntroductionState
     */
    'DRAFT'?: string;
    /**
     * 
     * @type {string}
     * @memberof AcceptorIntroductionState
     */
    'DENIED'?: string;
    /**
     * 
     * @type {string}
     * @memberof AcceptorIntroductionState
     */
    'DENIED_BY_REQUESTOR'?: string;
    /**
     * 
     * @type {string}
     * @memberof AcceptorIntroductionState
     */
    'DENIED_BY_INTRODUCER'?: string;
    /**
     * 
     * @type {string}
     * @memberof AcceptorIntroductionState
     */
    'ACCEPTED'?: string;
    /**
     * 
     * @type {string}
     * @memberof AcceptorIntroductionState
     */
    'AWAITING_ACCEPTOR'?: string;
}
/**
 * 
 * @export
 * @interface BulkCreateCommunitiesInput
 */
export interface BulkCreateCommunitiesInput {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkCreateCommunitiesInput
     */
    'community_ids': Array<string>;
}
/**
 * 
 * @export
 * @interface BulkCreatePeopleInput
 */
export interface BulkCreatePeopleInput {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkCreatePeopleInput
     */
    'user_ids': Array<string>;
}
/**
 * 
 * @export
 * @interface BulkGetCommunitiesInput
 */
export interface BulkGetCommunitiesInput {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkGetCommunitiesInput
     */
    'community_ids': Array<string>;
}
/**
 * 
 * @export
 * @interface BulkGetParentCommunitiesInput
 */
export interface BulkGetParentCommunitiesInput {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkGetParentCommunitiesInput
     */
    'child_community_ids': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof BulkGetParentCommunitiesInput
     */
    'is_active'?: boolean;
}
/**
 * 
 * @export
 * @interface BulkGetParentCommunitiesOutput
 */
export interface BulkGetParentCommunitiesOutput {
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof BulkGetParentCommunitiesOutput
     */
    'parent_communities': { [key: string]: Array<string>; };
}
/**
 * 
 * @export
 * @interface BulkGetPeopleInput
 */
export interface BulkGetPeopleInput {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkGetPeopleInput
     */
    'user_ids': Array<string>;
}
/**
 * 
 * @export
 * @interface CommunityInput
 */
export interface CommunityInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CommunityInput
     */
    'community_id': string;
}
/**
 * 
 * @export
 * @interface CommunityOrganizerOutput
 */
export interface CommunityOrganizerOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CommunityOrganizerOutput
     */
    'user_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityOrganizerOutput
     */
    'is_active': boolean;
    /**
     * 
     * @type {string}
     * @memberof CommunityOrganizerOutput
     */
    'created_date': string;
}
/**
 * 
 * @export
 * @interface CommunityOutput
 */
export interface CommunityOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CommunityOutput
     */
    'community_id': string;
}
/**
 * 
 * @export
 * @interface ConnectWithCodeInput
 */
export interface ConnectWithCodeInput {
    /**
     * 
     * @type {string}
     * @memberof ConnectWithCodeInput
     */
    'connection_code': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof ConnectWithCodeInput
     */
    'event_id'?: string;
}
/**
 * 
 * @export
 * @interface ConnectWithCodeOutput
 */
export interface ConnectWithCodeOutput {
    /**
     * 
     * @type {string}
     * @memberof ConnectWithCodeOutput
     */
    'message': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof ConnectWithCodeOutput
     */
    'connected_user_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof ConnectWithCodeOutput
     */
    'event_id'?: string;
}
/**
 * 
 * @export
 * @interface ConnectedWithCreateInput
 */
export interface ConnectedWithCreateInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof ConnectedWithCreateInput
     */
    'event_id'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof ConnectedWithCreateInput
     */
    'user_1_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof ConnectedWithCreateInput
     */
    'user_2_id': string;
}
/**
 * 
 * @export
 * @interface ConnectedWithInput
 */
export interface ConnectedWithInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof ConnectedWithInput
     */
    'user_1_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof ConnectedWithInput
     */
    'user_2_id': string;
}
/**
 * 
 * @export
 * @interface Connection
 */
export interface Connection {
    /**
     * 
     * @type {CreatedDate}
     * @memberof Connection
     */
    'created_date'?: CreatedDate;
    /**
     * 
     * @type {ModifiedDate}
     * @memberof Connection
     */
    'modified_date'?: ModifiedDate;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof Connection
     */
    'user_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof Connection
     */
    'is_active'?: boolean;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof Connection
     */
    'event_id'?: string;
}
/**
 * 
 * @export
 * @interface ConnectionCodeOutput
 */
export interface ConnectionCodeOutput {
    /**
     * 
     * @type {string}
     * @memberof ConnectionCodeOutput
     */
    'connection_code': string;
}
/**
 * Rating enum for connections between users (1-5 scale)
 * @export
 * @enum {string}
 */

export const ConnectionRating = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5
} as const;

export type ConnectionRating = typeof ConnectionRating[keyof typeof ConnectionRating];


/**
 * 
 * @export
 * @interface ConnectionRequestInput
 */
export interface ConnectionRequestInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof ConnectionRequestInput
     */
    'target_user_id': string;
}
/**
 * 
 * @export
 * @interface ConnectionStrengthOutput
 */
export interface ConnectionStrengthOutput {
    /**
     * 
     * @type {number}
     * @memberof ConnectionStrengthOutput
     */
    'connection_count': number;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof ConnectionStrengthOutput
     */
    'user_1_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof ConnectionStrengthOutput
     */
    'user_2_id': string;
}
/**
 * 
 * @export
 * @interface CreateSubcommunityInput
 */
export interface CreateSubcommunityInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateSubcommunityInput
     */
    'community_id': string;
}
/**
 * 
 * @export
 * @interface CreateSubcommunityOutput
 */
export interface CreateSubcommunityOutput {
    /**
     * 
     * @type {boolean}
     * @memberof CreateSubcommunityOutput
     */
    'is_active': boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateSubcommunityOutput
     */
    'created_date': string;
}
/**
 * 
 * @export
 * @interface CreatedDate
 */
export interface CreatedDate {
}
/**
 * 
 * @export
 * @interface DenyIntroInput
 */
export interface DenyIntroInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof DenyIntroInput
     */
    'id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof DenyIntroInput
     */
    'user_id': string;
}
/**
 * Represents any entity that can be followed
 * @export
 * @interface FollowableEntity
 */
export interface FollowableEntity {
    /**
     * 
     * @type {FollowableEntityType}
     * @memberof FollowableEntity
     */
    'entity_type': FollowableEntityType;
    /**
     * 
     * @type {string}
     * @memberof FollowableEntity
     */
    'entity_id': string;
}


/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const FollowableEntityType = {
    Person: 'person',
    Community: 'community'
} as const;

export type FollowableEntityType = typeof FollowableEntityType[keyof typeof FollowableEntityType];


/**
 * 
 * @export
 * @interface FollowsInput
 */
export interface FollowsInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof FollowsInput
     */
    'follower_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof FollowsInput
     */
    'followed_id': string;
    /**
     * 
     * @type {FollowableEntityType}
     * @memberof FollowsInput
     */
    'followed_entity_type': FollowableEntityType;
}


/**
 * 
 * @export
 * @interface HTTPValidationError
 */
export interface HTTPValidationError {
    /**
     * 
     * @type {Array<ValidationError>}
     * @memberof HTTPValidationError
     */
    'detail'?: Array<ValidationError>;
}
/**
 * 
 * @export
 * @interface IntroducedTo
 */
export interface IntroducedTo {
    /**
     * 
     * @type {boolean}
     * @memberof IntroducedTo
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {CreatedDate}
     * @memberof IntroducedTo
     */
    'created_date'?: CreatedDate;
    /**
     * 
     * @type {ModifiedDate}
     * @memberof IntroducedTo
     */
    'modified_date'?: ModifiedDate;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof IntroducedTo
     */
    'id'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof IntroducedTo
     */
    'introducer_id': string;
    /**
     * 
     * @type {IntroductionReadStatus}
     * @memberof IntroducedTo
     */
    'read_status': IntroductionReadStatus;
    /**
     * 
     * @type {State}
     * @memberof IntroducedTo
     */
    'state': State;
    /**
     * 
     * @type {string}
     * @memberof IntroducedTo
     */
    'introducer_message'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntroducedTo
     */
    'intro_video_url'?: string;
    /**
     * 
     * @type {IntroductionRole}
     * @memberof IntroducedTo
     */
    'intro_role': IntroductionRole;
}


/**
 * 
 * @export
 * @interface IntroducedToInput
 */
export interface IntroducedToInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof IntroducedToInput
     */
    'introduced_person_1_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof IntroducedToInput
     */
    'introduced_person_2_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof IntroducedToInput
     */
    'introducer_id': string;
    /**
     * 
     * @type {string}
     * @memberof IntroducedToInput
     */
    'introducer_message': string;
    /**
     * 
     * @type {IntroducedToInputState}
     * @memberof IntroducedToInput
     */
    'state'?: IntroducedToInputState;
}


/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const IntroducedToInputState = {
    Pending: 'pending',
    Draft: 'draft'
} as const;

export type IntroducedToInputState = typeof IntroducedToInputState[keyof typeof IntroducedToInputState];


/**
 * 
 * @export
 * @interface IntroducerAcceptIntroInput
 */
export interface IntroducerAcceptIntroInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof IntroducerAcceptIntroInput
     */
    'introduced_user_1_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof IntroducerAcceptIntroInput
     */
    'introduced_user_2_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof IntroducerAcceptIntroInput
     */
    'introducer_id': string;
    /**
     * 
     * @type {string}
     * @memberof IntroducerAcceptIntroInput
     */
    'introducer_message': string;
}
/**
 * 
 * @export
 * @interface Introduction
 */
export interface Introduction {
    /**
     * 
     * @type {Array<IntroductionHalf>}
     * @memberof Introduction
     */
    'introduction': Array<IntroductionHalf>;
}
/**
 * 
 * @export
 * @interface IntroductionHalf
 */
export interface IntroductionHalf {
    /**
     * 
     * @type {Person}
     * @memberof IntroductionHalf
     */
    'person': Person;
    /**
     * 
     * @type {IntroducedTo}
     * @memberof IntroductionHalf
     */
    'introduced_to': IntroducedTo;
}
/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const IntroductionReadStatus = {
    Pending: 'pending',
    Sent: 'sent',
    Seen: 'seen',
    Viewed: 'viewed'
} as const;

export type IntroductionReadStatus = typeof IntroductionReadStatus[keyof typeof IntroductionReadStatus];


/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const IntroductionRole = {
    Requestor: 'requestor',
    Acceptor: 'acceptor'
} as const;

export type IntroductionRole = typeof IntroductionRole[keyof typeof IntroductionRole];


/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const IntroductionsByMeStates = {
    Drafts: 'drafts',
    Pending: 'pending',
    Accepted: 'accepted',
    Denied: 'denied'
} as const;

export type IntroductionsByMeStates = typeof IntroductionsByMeStates[keyof typeof IntroductionsByMeStates];


/**
 * 
 * @export
 * @interface IsIntroducedInput
 */
export interface IsIntroducedInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof IsIntroducedInput
     */
    'user_1_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof IsIntroducedInput
     */
    'user_2_id': string;
}
/**
 * 
 * @export
 * @interface IsIntroducedOutput
 */
export interface IsIntroducedOutput {
    /**
     * 
     * @type {boolean}
     * @memberof IsIntroducedOutput
     */
    'is_introduced': boolean;
}
/**
 * 
 * @export
 * @interface IsMemberOfOutput
 */
export interface IsMemberOfOutput {
    /**
     * 
     * @type {boolean}
     * @memberof IsMemberOfOutput
     */
    'is_member': boolean;
}
/**
 * 
 * @export
 * @interface IsSubcommunityOfOutput
 */
export interface IsSubcommunityOfOutput {
    /**
     * 
     * @type {boolean}
     * @memberof IsSubcommunityOfOutput
     */
    'is_subcommunity': boolean;
}
/**
 * 
 * @export
 * @interface JoinCommunityInput
 */
export interface JoinCommunityInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof JoinCommunityInput
     */
    'community_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof JoinCommunityInput
     */
    'user_id': string;
}
/**
 * 
 * @export
 * @interface JoinCommunityOutput
 */
export interface JoinCommunityOutput {
    /**
     * 
     * @type {boolean}
     * @memberof JoinCommunityOutput
     */
    'is_active': boolean;
    /**
     * 
     * @type {string}
     * @memberof JoinCommunityOutput
     */
    'created_date': string;
}
/**
 * 
 * @export
 * @interface LeaveCommunityInput
 */
export interface LeaveCommunityInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof LeaveCommunityInput
     */
    'community_id': string;
}
/**
 * 
 * @export
 * @interface LeaveCommunityOutput
 */
export interface LeaveCommunityOutput {
    /**
     * 
     * @type {boolean}
     * @memberof LeaveCommunityOutput
     */
    'is_active': boolean;
    /**
     * 
     * @type {string}
     * @memberof LeaveCommunityOutput
     */
    'created_date': string;
}
/**
 * 
 * @export
 * @interface LocationInner
 */
export interface LocationInner {
}
/**
 * 
 * @export
 * @interface MemberOutput
 */
export interface MemberOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof MemberOutput
     */
    'user_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof MemberOutput
     */
    'is_active': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MemberOutput
     */
    'is_organizer': boolean;
    /**
     * 
     * @type {string}
     * @memberof MemberOutput
     */
    'created_date': string;
}
/**
 * 
 * @export
 * @interface MembershipCountOutput
 */
export interface MembershipCountOutput {
    /**
     * 
     * @type {number}
     * @memberof MembershipCountOutput
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface MembershipOutput
 */
export interface MembershipOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof MembershipOutput
     */
    'community_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof MembershipOutput
     */
    'is_active': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MembershipOutput
     */
    'is_organizer': boolean;
    /**
     * 
     * @type {string}
     * @memberof MembershipOutput
     */
    'created_date': string;
}
/**
 * 
 * @export
 * @interface ModifiedDate
 */
export interface ModifiedDate {
}
/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const MyIntroductionsStates = {
    Pending: 'pending',
    Accepted: 'accepted',
    Denied: 'denied'
} as const;

export type MyIntroductionsStates = typeof MyIntroductionsStates[keyof typeof MyIntroductionsStates];


/**
 * 
 * @export
 * @interface ParentCommunityOutput
 */
export interface ParentCommunityOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof ParentCommunityOutput
     */
    'parent_community_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof ParentCommunityOutput
     */
    'is_active': boolean;
    /**
     * 
     * @type {string}
     * @memberof ParentCommunityOutput
     */
    'created_date': string;
}
/**
 * 
 * @export
 * @interface PendingConnectionsOutput
 */
export interface PendingConnectionsOutput {
    /**
     * 
     * @type {Array<string>}
     * @memberof PendingConnectionsOutput
     */
    'pending_connections': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof PendingConnectionsOutput
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface Person
 */
export interface Person {
    /**
     * 
     * @type {CreatedDate}
     * @memberof Person
     */
    'created_date'?: CreatedDate;
    /**
     * 
     * @type {ModifiedDate}
     * @memberof Person
     */
    'modified_date'?: ModifiedDate;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof Person
     */
    'user_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof Person
     */
    'is_active'?: boolean;
}
/**
 * 
 * @export
 * @interface PersonInput
 */
export interface PersonInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof PersonInput
     */
    'user_id': string;
}
/**
 * Input for rating a connection
 * @export
 * @interface RateConnectionInput
 */
export interface RateConnectionInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof RateConnectionInput
     */
    'rated_user_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof RateConnectionInput
     */
    'event_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof RateConnectionInput
     */
    'connected_with_id': string;
    /**
     * 
     * @type {ConnectionRating}
     * @memberof RateConnectionInput
     */
    'rating': ConnectionRating;
    /**
     * 
     * @type {string}
     * @memberof RateConnectionInput
     */
    'comment'?: string;
}


/**
 * Output for rating a connection
 * @export
 * @interface RateConnectionOutput
 */
export interface RateConnectionOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof RateConnectionOutput
     */
    'event_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof RateConnectionOutput
     */
    'connected_with_id': string;
    /**
     * 
     * @type {number}
     * @memberof RateConnectionOutput
     */
    'rating': number;
    /**
     * 
     * @type {string}
     * @memberof RateConnectionOutput
     */
    'comment'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RateConnectionOutput
     */
    'is_active': boolean;
}
/**
 * Full rating schema with timestamps
 * @export
 * @interface Rates
 */
export interface Rates {
    /**
     * 
     * @type {CreatedDate}
     * @memberof Rates
     */
    'created_date'?: CreatedDate;
    /**
     * 
     * @type {ModifiedDate}
     * @memberof Rates
     */
    'modified_date'?: ModifiedDate;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof Rates
     */
    'event_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof Rates
     */
    'connected_with_id': string;
    /**
     * 
     * @type {ConnectionRating}
     * @memberof Rates
     */
    'rating': ConnectionRating;
    /**
     * 
     * @type {string}
     * @memberof Rates
     */
    'comment'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Rates
     */
    'is_active': boolean;
}


/**
 * Output for rating count
 * @export
 * @interface RatingCountOutput
 */
export interface RatingCountOutput {
    /**
     * 
     * @type {number}
     * @memberof RatingCountOutput
     */
    'count': number;
}
/**
 * Output showing a rating with person details
 * @export
 * @interface RatingWithPersonOutput
 */
export interface RatingWithPersonOutput {
    /**
     * 
     * @type {Person}
     * @memberof RatingWithPersonOutput
     */
    'person': Person;
    /**
     * 
     * @type {Rates}
     * @memberof RatingWithPersonOutput
     */
    'rating': Rates;
}
/**
 * 
 * @export
 * @interface RelationshipStats
 */
export interface RelationshipStats {
    /**
     * 
     * @type {number}
     * @memberof RelationshipStats
     */
    'connection_count': number;
    /**
     * 
     * @type {number}
     * @memberof RelationshipStats
     */
    'follower_count': number;
    /**
     * 
     * @type {number}
     * @memberof RelationshipStats
     */
    'following_count': number;
}
/**
 * 
 * @export
 * @interface RemoveSubcommunityOutput
 */
export interface RemoveSubcommunityOutput {
    /**
     * 
     * @type {boolean}
     * @memberof RemoveSubcommunityOutput
     */
    'is_active': boolean;
    /**
     * 
     * @type {string}
     * @memberof RemoveSubcommunityOutput
     */
    'created_date': string;
}
/**
 * 
 * @export
 * @interface RequestorIntroductionState
 */
export interface RequestorIntroductionState {
    /**
     * 
     * @type {string}
     * @memberof RequestorIntroductionState
     */
    'DRAFT'?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestorIntroductionState
     */
    'DENIED'?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestorIntroductionState
     */
    'DENIED_BY_ACCEPTOR'?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestorIntroductionState
     */
    'DENIED_BY_INTRODUCER'?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestorIntroductionState
     */
    'ACCEPTED'?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestorIntroductionState
     */
    'AWAITING_VIDEO'?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestorIntroductionState
     */
    'VIDEO_COMPLETED'?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestorIntroductionState
     */
    'SENT_TO_ACCEPTOR'?: string;
}
/**
 * 
 * @export
 * @interface State
 */
export interface State {
    /**
     * 
     * @type {string}
     * @memberof State
     */
    'DRAFT'?: string;
    /**
     * 
     * @type {string}
     * @memberof State
     */
    'DENIED'?: string;
    /**
     * 
     * @type {string}
     * @memberof State
     */
    'DENIED_BY_ACCEPTOR'?: string;
    /**
     * 
     * @type {string}
     * @memberof State
     */
    'DENIED_BY_INTRODUCER'?: string;
    /**
     * 
     * @type {string}
     * @memberof State
     */
    'ACCEPTED'?: string;
    /**
     * 
     * @type {string}
     * @memberof State
     */
    'AWAITING_VIDEO'?: string;
    /**
     * 
     * @type {string}
     * @memberof State
     */
    'VIDEO_COMPLETED'?: string;
    /**
     * 
     * @type {string}
     * @memberof State
     */
    'SENT_TO_ACCEPTOR'?: string;
    /**
     * 
     * @type {string}
     * @memberof State
     */
    'AWAITING_INTRODUCER'?: string;
    /**
     * 
     * @type {string}
     * @memberof State
     */
    'AWAITING_REQUESTOR'?: string;
    /**
     * 
     * @type {string}
     * @memberof State
     */
    'DENIED_BY_REQUESTOR'?: string;
    /**
     * 
     * @type {string}
     * @memberof State
     */
    'AWAITING_ACCEPTOR'?: string;
}
/**
 * 
 * @export
 * @interface SubcommunityCountOutput
 */
export interface SubcommunityCountOutput {
    /**
     * 
     * @type {number}
     * @memberof SubcommunityCountOutput
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface SubcommunityOutput
 */
export interface SubcommunityOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SubcommunityOutput
     */
    'child_community_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof SubcommunityOutput
     */
    'is_active': boolean;
    /**
     * 
     * @type {string}
     * @memberof SubcommunityOutput
     */
    'created_date'?: string;
    /**
     * 
     * @type {number}
     * @memberof SubcommunityOutput
     */
    'depth_level': number;
}
/**
 * 
 * @export
 * @interface UnreviewedConnectionsOutput
 */
export interface UnreviewedConnectionsOutput {
    /**
     * 
     * @type {Array<string>}
     * @memberof UnreviewedConnectionsOutput
     */
    'unreviewed_connections': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof UnreviewedConnectionsOutput
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface UpdateMemberOrganizerStatusInput
 */
export interface UpdateMemberOrganizerStatusInput {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateMemberOrganizerStatusInput
     */
    'is_organizer': boolean;
}
/**
 * 
 * @export
 * @interface UpdateMemberOrganizerStatusOutput
 */
export interface UpdateMemberOrganizerStatusOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof UpdateMemberOrganizerStatusOutput
     */
    'user_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateMemberOrganizerStatusOutput
     */
    'is_organizer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateMemberOrganizerStatusOutput
     */
    'is_active': boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateMemberOrganizerStatusOutput
     */
    'created_date': string;
}
/**
 * Output for user ratings (given or received)
 * @export
 * @interface UserRatingsOutput
 */
export interface UserRatingsOutput {
    /**
     * 
     * @type {Array<RatingWithPersonOutput>}
     * @memberof UserRatingsOutput
     */
    'ratings': Array<RatingWithPersonOutput>;
    /**
     * 
     * @type {number}
     * @memberof UserRatingsOutput
     */
    'average_rating'?: number;
}
/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {Array<LocationInner>}
     * @memberof ValidationError
     */
    'loc': Array<LocationInner>;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'msg': string;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'type': string;
}

/**
 * CommunitiesApi - axios parameter creator
 * @export
 */
export const CommunitiesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Bulk Create Communities
         * @param {BulkCreateCommunitiesInput} bulkCreateCommunitiesInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkCreateCommunitiesCommunitiesBulkCreatePost: async (bulkCreateCommunitiesInput: BulkCreateCommunitiesInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkCreateCommunitiesInput' is not null or undefined
            assertParamExists('bulkCreateCommunitiesCommunitiesBulkCreatePost', 'bulkCreateCommunitiesInput', bulkCreateCommunitiesInput)
            const localVarPath = `/communities/bulk_create/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkCreateCommunitiesInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Bulk Get Communities
         * @param {BulkGetCommunitiesInput} bulkGetCommunitiesInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetCommunitiesCommunitiesBulkPost: async (bulkGetCommunitiesInput: BulkGetCommunitiesInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkGetCommunitiesInput' is not null or undefined
            assertParamExists('bulkGetCommunitiesCommunitiesBulkPost', 'bulkGetCommunitiesInput', bulkGetCommunitiesInput)
            const localVarPath = `/communities/bulk/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkGetCommunitiesInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Community
         * @param {CommunityInput} communityInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCommunityCommunitiesPost: async (communityInput: CommunityInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityInput' is not null or undefined
            assertParamExists('createCommunityCommunitiesPost', 'communityInput', communityInput)
            const localVarPath = `/communities/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(communityInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Community By Id
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommunityByIdCommunitiesCommunityIdGet: async (communityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('getCommunityByIdCommunitiesCommunityIdGet', 'communityId', communityId)
            const localVarPath = `/communities/{community_id}/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List All Communities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllCommunitiesCommunitiesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/communities/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommunitiesApi - functional programming interface
 * @export
 */
export const CommunitiesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CommunitiesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Bulk Create Communities
         * @param {BulkCreateCommunitiesInput} bulkCreateCommunitiesInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkCreateCommunitiesCommunitiesBulkCreatePost(bulkCreateCommunitiesInput: BulkCreateCommunitiesInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CommunityOutput>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkCreateCommunitiesCommunitiesBulkCreatePost(bulkCreateCommunitiesInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommunitiesApi.bulkCreateCommunitiesCommunitiesBulkCreatePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Bulk Get Communities
         * @param {BulkGetCommunitiesInput} bulkGetCommunitiesInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkGetCommunitiesCommunitiesBulkPost(bulkGetCommunitiesInput: BulkGetCommunitiesInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CommunityOutput>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkGetCommunitiesCommunitiesBulkPost(bulkGetCommunitiesInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommunitiesApi.bulkGetCommunitiesCommunitiesBulkPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Create Community
         * @param {CommunityInput} communityInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCommunityCommunitiesPost(communityInput: CommunityInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunityOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCommunityCommunitiesPost(communityInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommunitiesApi.createCommunityCommunitiesPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Community By Id
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommunityByIdCommunitiesCommunityIdGet(communityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunityOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommunityByIdCommunitiesCommunityIdGet(communityId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommunitiesApi.getCommunityByIdCommunitiesCommunityIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary List All Communities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAllCommunitiesCommunitiesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CommunityOutput>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAllCommunitiesCommunitiesGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommunitiesApi.listAllCommunitiesCommunitiesGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * CommunitiesApi - factory interface
 * @export
 */
export const CommunitiesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CommunitiesApiFp(configuration)
    return {
        /**
         * 
         * @summary Bulk Create Communities
         * @param {CommunitiesApiBulkCreateCommunitiesCommunitiesBulkCreatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkCreateCommunitiesCommunitiesBulkCreatePost(requestParameters: CommunitiesApiBulkCreateCommunitiesCommunitiesBulkCreatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<CommunityOutput>> {
            return localVarFp.bulkCreateCommunitiesCommunitiesBulkCreatePost(requestParameters.bulkCreateCommunitiesInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Bulk Get Communities
         * @param {CommunitiesApiBulkGetCommunitiesCommunitiesBulkPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetCommunitiesCommunitiesBulkPost(requestParameters: CommunitiesApiBulkGetCommunitiesCommunitiesBulkPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<CommunityOutput>> {
            return localVarFp.bulkGetCommunitiesCommunitiesBulkPost(requestParameters.bulkGetCommunitiesInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Community
         * @param {CommunitiesApiCreateCommunityCommunitiesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCommunityCommunitiesPost(requestParameters: CommunitiesApiCreateCommunityCommunitiesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommunityOutput> {
            return localVarFp.createCommunityCommunitiesPost(requestParameters.communityInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Community By Id
         * @param {CommunitiesApiGetCommunityByIdCommunitiesCommunityIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommunityByIdCommunitiesCommunityIdGet(requestParameters: CommunitiesApiGetCommunityByIdCommunitiesCommunityIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommunityOutput> {
            return localVarFp.getCommunityByIdCommunitiesCommunityIdGet(requestParameters.communityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List All Communities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllCommunitiesCommunitiesGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<CommunityOutput>> {
            return localVarFp.listAllCommunitiesCommunitiesGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for bulkCreateCommunitiesCommunitiesBulkCreatePost operation in CommunitiesApi.
 * @export
 * @interface CommunitiesApiBulkCreateCommunitiesCommunitiesBulkCreatePostRequest
 */
export interface CommunitiesApiBulkCreateCommunitiesCommunitiesBulkCreatePostRequest {
    /**
     * 
     * @type {BulkCreateCommunitiesInput}
     * @memberof CommunitiesApiBulkCreateCommunitiesCommunitiesBulkCreatePost
     */
    readonly bulkCreateCommunitiesInput: BulkCreateCommunitiesInput
}

/**
 * Request parameters for bulkGetCommunitiesCommunitiesBulkPost operation in CommunitiesApi.
 * @export
 * @interface CommunitiesApiBulkGetCommunitiesCommunitiesBulkPostRequest
 */
export interface CommunitiesApiBulkGetCommunitiesCommunitiesBulkPostRequest {
    /**
     * 
     * @type {BulkGetCommunitiesInput}
     * @memberof CommunitiesApiBulkGetCommunitiesCommunitiesBulkPost
     */
    readonly bulkGetCommunitiesInput: BulkGetCommunitiesInput
}

/**
 * Request parameters for createCommunityCommunitiesPost operation in CommunitiesApi.
 * @export
 * @interface CommunitiesApiCreateCommunityCommunitiesPostRequest
 */
export interface CommunitiesApiCreateCommunityCommunitiesPostRequest {
    /**
     * 
     * @type {CommunityInput}
     * @memberof CommunitiesApiCreateCommunityCommunitiesPost
     */
    readonly communityInput: CommunityInput
}

/**
 * Request parameters for getCommunityByIdCommunitiesCommunityIdGet operation in CommunitiesApi.
 * @export
 * @interface CommunitiesApiGetCommunityByIdCommunitiesCommunityIdGetRequest
 */
export interface CommunitiesApiGetCommunityByIdCommunitiesCommunityIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof CommunitiesApiGetCommunityByIdCommunitiesCommunityIdGet
     */
    readonly communityId: string
}

/**
 * CommunitiesApi - object-oriented interface
 * @export
 * @class CommunitiesApi
 * @extends {BaseAPI}
 */
export class CommunitiesApi extends BaseAPI {
    /**
     * 
     * @summary Bulk Create Communities
     * @param {CommunitiesApiBulkCreateCommunitiesCommunitiesBulkCreatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunitiesApi
     */
    public bulkCreateCommunitiesCommunitiesBulkCreatePost(requestParameters: CommunitiesApiBulkCreateCommunitiesCommunitiesBulkCreatePostRequest, options?: RawAxiosRequestConfig) {
        return CommunitiesApiFp(this.configuration).bulkCreateCommunitiesCommunitiesBulkCreatePost(requestParameters.bulkCreateCommunitiesInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Bulk Get Communities
     * @param {CommunitiesApiBulkGetCommunitiesCommunitiesBulkPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunitiesApi
     */
    public bulkGetCommunitiesCommunitiesBulkPost(requestParameters: CommunitiesApiBulkGetCommunitiesCommunitiesBulkPostRequest, options?: RawAxiosRequestConfig) {
        return CommunitiesApiFp(this.configuration).bulkGetCommunitiesCommunitiesBulkPost(requestParameters.bulkGetCommunitiesInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Community
     * @param {CommunitiesApiCreateCommunityCommunitiesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunitiesApi
     */
    public createCommunityCommunitiesPost(requestParameters: CommunitiesApiCreateCommunityCommunitiesPostRequest, options?: RawAxiosRequestConfig) {
        return CommunitiesApiFp(this.configuration).createCommunityCommunitiesPost(requestParameters.communityInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Community By Id
     * @param {CommunitiesApiGetCommunityByIdCommunitiesCommunityIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunitiesApi
     */
    public getCommunityByIdCommunitiesCommunityIdGet(requestParameters: CommunitiesApiGetCommunityByIdCommunitiesCommunityIdGetRequest, options?: RawAxiosRequestConfig) {
        return CommunitiesApiFp(this.configuration).getCommunityByIdCommunitiesCommunityIdGet(requestParameters.communityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List All Communities
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunitiesApi
     */
    public listAllCommunitiesCommunitiesGet(options?: RawAxiosRequestConfig) {
        return CommunitiesApiFp(this.configuration).listAllCommunitiesCommunitiesGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ConnectionsApi - axios parameter creator
 * @export
 */
export const ConnectionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Accept a connection request (creates reciprocal relationship)
         * @summary Accept Connection Request
         * @param {ConnectionRequestInput} connectionRequestInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptConnectionRequestConnectionsAcceptConnectionPost: async (connectionRequestInput: ConnectionRequestInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectionRequestInput' is not null or undefined
            assertParamExists('acceptConnectionRequestConnectionsAcceptConnectionPost', 'connectionRequestInput', connectionRequestInput)
            const localVarPath = `/connections/accept-connection/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(connectionRequestInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Connect with another user using a connection code
         * @summary Connect With Code
         * @param {ConnectWithCodeInput} connectWithCodeInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectWithCodeConnectionsConnectWithCodePost: async (connectWithCodeInput: ConnectWithCodeInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectWithCodeInput' is not null or undefined
            assertParamExists('connectWithCodeConnectionsConnectWithCodePost', 'connectWithCodeInput', connectWithCodeInput)
            const localVarPath = `/connections/connect-with-code/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(connectWithCodeInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Connection
         * @param {ConnectedWithCreateInput} connectedWithCreateInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createConnectionConnectionsPost: async (connectedWithCreateInput: ConnectedWithCreateInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectedWithCreateInput' is not null or undefined
            assertParamExists('createConnectionConnectionsPost', 'connectedWithCreateInput', connectedWithCreateInput)
            const localVarPath = `/connections/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(connectedWithCreateInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate a unique connection code for establishing connections (admin only)
         * @summary Generate Connection Code
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateConnectionCodeConnectionsGenerateConnectionCodeUsersUserIdPost: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('generateConnectionCodeConnectionsGenerateConnectionCodeUsersUserIdPost', 'userId', userId)
            const localVarPath = `/connections/generate-connection-code/users/{user_id}/`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Connection Path
         * @param {ConnectedWithInput} connectedWithInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnectionPathConnectionsConnectionPathPost: async (connectedWithInput: ConnectedWithInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectedWithInput' is not null or undefined
            assertParamExists('getConnectionPathConnectionsConnectionPathPost', 'connectedWithInput', connectedWithInput)
            const localVarPath = `/connections/connection-path/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(connectedWithInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the connection strength (number of cycles) between two users
         * @summary Get Connection Strength
         * @param {string} user1Id 
         * @param {string} user2Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnectionStrengthConnectionsConnectionStrengthGet: async (user1Id: string, user2Id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'user1Id' is not null or undefined
            assertParamExists('getConnectionStrengthConnectionsConnectionStrengthGet', 'user1Id', user1Id)
            // verify required parameter 'user2Id' is not null or undefined
            assertParamExists('getConnectionStrengthConnectionsConnectionStrengthGet', 'user2Id', user2Id)
            const localVarPath = `/connections/connection-strength/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (user1Id !== undefined) {
                localVarQueryParameter['user_1_id'] = user1Id;
            }

            if (user2Id !== undefined) {
                localVarQueryParameter['user_2_id'] = user2Id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Connections
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnectionsConnectionsUserIdGet: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getConnectionsConnectionsUserIdGet', 'userId', userId)
            const localVarPath = `/connections/{user_id}/`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get connections for a user at a specific event (admin or data owner)
         * @summary Get Connections For Event
         * @param {string} userId 
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnectionsForEventConnectionsUserIdEventEventIdGet: async (userId: string, eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getConnectionsForEventConnectionsUserIdEventEventIdGet', 'userId', userId)
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getConnectionsForEventConnectionsUserIdEventEventIdGet', 'eventId', eventId)
            const localVarPath = `/connections/{user_id}/event/{event_id}/`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all pending connection requests sent by the user
         * @summary Get Pending Connections
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingConnectionsConnectionsPendingConnectionsUserIdGet: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getPendingConnectionsConnectionsPendingConnectionsUserIdGet', 'userId', userId)
            const localVarPath = `/connections/pending-connections/{user_id}/`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all unreviewed connection requests received by the user
         * @summary Get Unreviewed Connections
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnreviewedConnectionsConnectionsUnreviewedConnectionsUserIdGet: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUnreviewedConnectionsConnectionsUnreviewedConnectionsUserIdGet', 'userId', userId)
            const localVarPath = `/connections/unreviewed-connections/{user_id}/`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConnectionsApi - functional programming interface
 * @export
 */
export const ConnectionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConnectionsApiAxiosParamCreator(configuration)
    return {
        /**
         * Accept a connection request (creates reciprocal relationship)
         * @summary Accept Connection Request
         * @param {ConnectionRequestInput} connectionRequestInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptConnectionRequestConnectionsAcceptConnectionPost(connectionRequestInput: ConnectionRequestInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Person>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptConnectionRequestConnectionsAcceptConnectionPost(connectionRequestInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ConnectionsApi.acceptConnectionRequestConnectionsAcceptConnectionPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Connect with another user using a connection code
         * @summary Connect With Code
         * @param {ConnectWithCodeInput} connectWithCodeInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async connectWithCodeConnectionsConnectWithCodePost(connectWithCodeInput: ConnectWithCodeInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConnectWithCodeOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.connectWithCodeConnectionsConnectWithCodePost(connectWithCodeInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ConnectionsApi.connectWithCodeConnectionsConnectWithCodePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Create Connection
         * @param {ConnectedWithCreateInput} connectedWithCreateInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createConnectionConnectionsPost(connectedWithCreateInput: ConnectedWithCreateInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Person>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createConnectionConnectionsPost(connectedWithCreateInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ConnectionsApi.createConnectionConnectionsPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Generate a unique connection code for establishing connections (admin only)
         * @summary Generate Connection Code
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateConnectionCodeConnectionsGenerateConnectionCodeUsersUserIdPost(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConnectionCodeOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateConnectionCodeConnectionsGenerateConnectionCodeUsersUserIdPost(userId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ConnectionsApi.generateConnectionCodeConnectionsGenerateConnectionCodeUsersUserIdPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Connection Path
         * @param {ConnectedWithInput} connectedWithInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConnectionPathConnectionsConnectionPathPost(connectedWithInput: ConnectedWithInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Person>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConnectionPathConnectionsConnectionPathPost(connectedWithInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ConnectionsApi.getConnectionPathConnectionsConnectionPathPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get the connection strength (number of cycles) between two users
         * @summary Get Connection Strength
         * @param {string} user1Id 
         * @param {string} user2Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConnectionStrengthConnectionsConnectionStrengthGet(user1Id: string, user2Id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConnectionStrengthOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConnectionStrengthConnectionsConnectionStrengthGet(user1Id, user2Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ConnectionsApi.getConnectionStrengthConnectionsConnectionStrengthGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Connections
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConnectionsConnectionsUserIdGet(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Person>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConnectionsConnectionsUserIdGet(userId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ConnectionsApi.getConnectionsConnectionsUserIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get connections for a user at a specific event (admin or data owner)
         * @summary Get Connections For Event
         * @param {string} userId 
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConnectionsForEventConnectionsUserIdEventEventIdGet(userId: string, eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Connection>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConnectionsForEventConnectionsUserIdEventEventIdGet(userId, eventId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ConnectionsApi.getConnectionsForEventConnectionsUserIdEventEventIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get all pending connection requests sent by the user
         * @summary Get Pending Connections
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPendingConnectionsConnectionsPendingConnectionsUserIdGet(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PendingConnectionsOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPendingConnectionsConnectionsPendingConnectionsUserIdGet(userId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ConnectionsApi.getPendingConnectionsConnectionsPendingConnectionsUserIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get all unreviewed connection requests received by the user
         * @summary Get Unreviewed Connections
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnreviewedConnectionsConnectionsUnreviewedConnectionsUserIdGet(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnreviewedConnectionsOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUnreviewedConnectionsConnectionsUnreviewedConnectionsUserIdGet(userId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ConnectionsApi.getUnreviewedConnectionsConnectionsUnreviewedConnectionsUserIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * ConnectionsApi - factory interface
 * @export
 */
export const ConnectionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConnectionsApiFp(configuration)
    return {
        /**
         * Accept a connection request (creates reciprocal relationship)
         * @summary Accept Connection Request
         * @param {ConnectionsApiAcceptConnectionRequestConnectionsAcceptConnectionPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptConnectionRequestConnectionsAcceptConnectionPost(requestParameters: ConnectionsApiAcceptConnectionRequestConnectionsAcceptConnectionPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Person>> {
            return localVarFp.acceptConnectionRequestConnectionsAcceptConnectionPost(requestParameters.connectionRequestInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Connect with another user using a connection code
         * @summary Connect With Code
         * @param {ConnectionsApiConnectWithCodeConnectionsConnectWithCodePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectWithCodeConnectionsConnectWithCodePost(requestParameters: ConnectionsApiConnectWithCodeConnectionsConnectWithCodePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConnectWithCodeOutput> {
            return localVarFp.connectWithCodeConnectionsConnectWithCodePost(requestParameters.connectWithCodeInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Connection
         * @param {ConnectionsApiCreateConnectionConnectionsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createConnectionConnectionsPost(requestParameters: ConnectionsApiCreateConnectionConnectionsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Person>> {
            return localVarFp.createConnectionConnectionsPost(requestParameters.connectedWithCreateInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate a unique connection code for establishing connections (admin only)
         * @summary Generate Connection Code
         * @param {ConnectionsApiGenerateConnectionCodeConnectionsGenerateConnectionCodeUsersUserIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateConnectionCodeConnectionsGenerateConnectionCodeUsersUserIdPost(requestParameters: ConnectionsApiGenerateConnectionCodeConnectionsGenerateConnectionCodeUsersUserIdPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConnectionCodeOutput> {
            return localVarFp.generateConnectionCodeConnectionsGenerateConnectionCodeUsersUserIdPost(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Connection Path
         * @param {ConnectionsApiGetConnectionPathConnectionsConnectionPathPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnectionPathConnectionsConnectionPathPost(requestParameters: ConnectionsApiGetConnectionPathConnectionsConnectionPathPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Person>> {
            return localVarFp.getConnectionPathConnectionsConnectionPathPost(requestParameters.connectedWithInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the connection strength (number of cycles) between two users
         * @summary Get Connection Strength
         * @param {ConnectionsApiGetConnectionStrengthConnectionsConnectionStrengthGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnectionStrengthConnectionsConnectionStrengthGet(requestParameters: ConnectionsApiGetConnectionStrengthConnectionsConnectionStrengthGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConnectionStrengthOutput> {
            return localVarFp.getConnectionStrengthConnectionsConnectionStrengthGet(requestParameters.user1Id, requestParameters.user2Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Connections
         * @param {ConnectionsApiGetConnectionsConnectionsUserIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnectionsConnectionsUserIdGet(requestParameters: ConnectionsApiGetConnectionsConnectionsUserIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Person>> {
            return localVarFp.getConnectionsConnectionsUserIdGet(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get connections for a user at a specific event (admin or data owner)
         * @summary Get Connections For Event
         * @param {ConnectionsApiGetConnectionsForEventConnectionsUserIdEventEventIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnectionsForEventConnectionsUserIdEventEventIdGet(requestParameters: ConnectionsApiGetConnectionsForEventConnectionsUserIdEventEventIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Connection>> {
            return localVarFp.getConnectionsForEventConnectionsUserIdEventEventIdGet(requestParameters.userId, requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all pending connection requests sent by the user
         * @summary Get Pending Connections
         * @param {ConnectionsApiGetPendingConnectionsConnectionsPendingConnectionsUserIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingConnectionsConnectionsPendingConnectionsUserIdGet(requestParameters: ConnectionsApiGetPendingConnectionsConnectionsPendingConnectionsUserIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PendingConnectionsOutput> {
            return localVarFp.getPendingConnectionsConnectionsPendingConnectionsUserIdGet(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all unreviewed connection requests received by the user
         * @summary Get Unreviewed Connections
         * @param {ConnectionsApiGetUnreviewedConnectionsConnectionsUnreviewedConnectionsUserIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnreviewedConnectionsConnectionsUnreviewedConnectionsUserIdGet(requestParameters: ConnectionsApiGetUnreviewedConnectionsConnectionsUnreviewedConnectionsUserIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnreviewedConnectionsOutput> {
            return localVarFp.getUnreviewedConnectionsConnectionsUnreviewedConnectionsUserIdGet(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for acceptConnectionRequestConnectionsAcceptConnectionPost operation in ConnectionsApi.
 * @export
 * @interface ConnectionsApiAcceptConnectionRequestConnectionsAcceptConnectionPostRequest
 */
export interface ConnectionsApiAcceptConnectionRequestConnectionsAcceptConnectionPostRequest {
    /**
     * 
     * @type {ConnectionRequestInput}
     * @memberof ConnectionsApiAcceptConnectionRequestConnectionsAcceptConnectionPost
     */
    readonly connectionRequestInput: ConnectionRequestInput
}

/**
 * Request parameters for connectWithCodeConnectionsConnectWithCodePost operation in ConnectionsApi.
 * @export
 * @interface ConnectionsApiConnectWithCodeConnectionsConnectWithCodePostRequest
 */
export interface ConnectionsApiConnectWithCodeConnectionsConnectWithCodePostRequest {
    /**
     * 
     * @type {ConnectWithCodeInput}
     * @memberof ConnectionsApiConnectWithCodeConnectionsConnectWithCodePost
     */
    readonly connectWithCodeInput: ConnectWithCodeInput
}

/**
 * Request parameters for createConnectionConnectionsPost operation in ConnectionsApi.
 * @export
 * @interface ConnectionsApiCreateConnectionConnectionsPostRequest
 */
export interface ConnectionsApiCreateConnectionConnectionsPostRequest {
    /**
     * 
     * @type {ConnectedWithCreateInput}
     * @memberof ConnectionsApiCreateConnectionConnectionsPost
     */
    readonly connectedWithCreateInput: ConnectedWithCreateInput
}

/**
 * Request parameters for generateConnectionCodeConnectionsGenerateConnectionCodeUsersUserIdPost operation in ConnectionsApi.
 * @export
 * @interface ConnectionsApiGenerateConnectionCodeConnectionsGenerateConnectionCodeUsersUserIdPostRequest
 */
export interface ConnectionsApiGenerateConnectionCodeConnectionsGenerateConnectionCodeUsersUserIdPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ConnectionsApiGenerateConnectionCodeConnectionsGenerateConnectionCodeUsersUserIdPost
     */
    readonly userId: string
}

/**
 * Request parameters for getConnectionPathConnectionsConnectionPathPost operation in ConnectionsApi.
 * @export
 * @interface ConnectionsApiGetConnectionPathConnectionsConnectionPathPostRequest
 */
export interface ConnectionsApiGetConnectionPathConnectionsConnectionPathPostRequest {
    /**
     * 
     * @type {ConnectedWithInput}
     * @memberof ConnectionsApiGetConnectionPathConnectionsConnectionPathPost
     */
    readonly connectedWithInput: ConnectedWithInput
}

/**
 * Request parameters for getConnectionStrengthConnectionsConnectionStrengthGet operation in ConnectionsApi.
 * @export
 * @interface ConnectionsApiGetConnectionStrengthConnectionsConnectionStrengthGetRequest
 */
export interface ConnectionsApiGetConnectionStrengthConnectionsConnectionStrengthGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ConnectionsApiGetConnectionStrengthConnectionsConnectionStrengthGet
     */
    readonly user1Id: string

    /**
     * 
     * @type {string}
     * @memberof ConnectionsApiGetConnectionStrengthConnectionsConnectionStrengthGet
     */
    readonly user2Id: string
}

/**
 * Request parameters for getConnectionsConnectionsUserIdGet operation in ConnectionsApi.
 * @export
 * @interface ConnectionsApiGetConnectionsConnectionsUserIdGetRequest
 */
export interface ConnectionsApiGetConnectionsConnectionsUserIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ConnectionsApiGetConnectionsConnectionsUserIdGet
     */
    readonly userId: string
}

/**
 * Request parameters for getConnectionsForEventConnectionsUserIdEventEventIdGet operation in ConnectionsApi.
 * @export
 * @interface ConnectionsApiGetConnectionsForEventConnectionsUserIdEventEventIdGetRequest
 */
export interface ConnectionsApiGetConnectionsForEventConnectionsUserIdEventEventIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ConnectionsApiGetConnectionsForEventConnectionsUserIdEventEventIdGet
     */
    readonly userId: string

    /**
     * 
     * @type {string}
     * @memberof ConnectionsApiGetConnectionsForEventConnectionsUserIdEventEventIdGet
     */
    readonly eventId: string
}

/**
 * Request parameters for getPendingConnectionsConnectionsPendingConnectionsUserIdGet operation in ConnectionsApi.
 * @export
 * @interface ConnectionsApiGetPendingConnectionsConnectionsPendingConnectionsUserIdGetRequest
 */
export interface ConnectionsApiGetPendingConnectionsConnectionsPendingConnectionsUserIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ConnectionsApiGetPendingConnectionsConnectionsPendingConnectionsUserIdGet
     */
    readonly userId: string
}

/**
 * Request parameters for getUnreviewedConnectionsConnectionsUnreviewedConnectionsUserIdGet operation in ConnectionsApi.
 * @export
 * @interface ConnectionsApiGetUnreviewedConnectionsConnectionsUnreviewedConnectionsUserIdGetRequest
 */
export interface ConnectionsApiGetUnreviewedConnectionsConnectionsUnreviewedConnectionsUserIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ConnectionsApiGetUnreviewedConnectionsConnectionsUnreviewedConnectionsUserIdGet
     */
    readonly userId: string
}

/**
 * ConnectionsApi - object-oriented interface
 * @export
 * @class ConnectionsApi
 * @extends {BaseAPI}
 */
export class ConnectionsApi extends BaseAPI {
    /**
     * Accept a connection request (creates reciprocal relationship)
     * @summary Accept Connection Request
     * @param {ConnectionsApiAcceptConnectionRequestConnectionsAcceptConnectionPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConnectionsApi
     */
    public acceptConnectionRequestConnectionsAcceptConnectionPost(requestParameters: ConnectionsApiAcceptConnectionRequestConnectionsAcceptConnectionPostRequest, options?: RawAxiosRequestConfig) {
        return ConnectionsApiFp(this.configuration).acceptConnectionRequestConnectionsAcceptConnectionPost(requestParameters.connectionRequestInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Connect with another user using a connection code
     * @summary Connect With Code
     * @param {ConnectionsApiConnectWithCodeConnectionsConnectWithCodePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConnectionsApi
     */
    public connectWithCodeConnectionsConnectWithCodePost(requestParameters: ConnectionsApiConnectWithCodeConnectionsConnectWithCodePostRequest, options?: RawAxiosRequestConfig) {
        return ConnectionsApiFp(this.configuration).connectWithCodeConnectionsConnectWithCodePost(requestParameters.connectWithCodeInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Connection
     * @param {ConnectionsApiCreateConnectionConnectionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConnectionsApi
     */
    public createConnectionConnectionsPost(requestParameters: ConnectionsApiCreateConnectionConnectionsPostRequest, options?: RawAxiosRequestConfig) {
        return ConnectionsApiFp(this.configuration).createConnectionConnectionsPost(requestParameters.connectedWithCreateInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate a unique connection code for establishing connections (admin only)
     * @summary Generate Connection Code
     * @param {ConnectionsApiGenerateConnectionCodeConnectionsGenerateConnectionCodeUsersUserIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConnectionsApi
     */
    public generateConnectionCodeConnectionsGenerateConnectionCodeUsersUserIdPost(requestParameters: ConnectionsApiGenerateConnectionCodeConnectionsGenerateConnectionCodeUsersUserIdPostRequest, options?: RawAxiosRequestConfig) {
        return ConnectionsApiFp(this.configuration).generateConnectionCodeConnectionsGenerateConnectionCodeUsersUserIdPost(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Connection Path
     * @param {ConnectionsApiGetConnectionPathConnectionsConnectionPathPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConnectionsApi
     */
    public getConnectionPathConnectionsConnectionPathPost(requestParameters: ConnectionsApiGetConnectionPathConnectionsConnectionPathPostRequest, options?: RawAxiosRequestConfig) {
        return ConnectionsApiFp(this.configuration).getConnectionPathConnectionsConnectionPathPost(requestParameters.connectedWithInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the connection strength (number of cycles) between two users
     * @summary Get Connection Strength
     * @param {ConnectionsApiGetConnectionStrengthConnectionsConnectionStrengthGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConnectionsApi
     */
    public getConnectionStrengthConnectionsConnectionStrengthGet(requestParameters: ConnectionsApiGetConnectionStrengthConnectionsConnectionStrengthGetRequest, options?: RawAxiosRequestConfig) {
        return ConnectionsApiFp(this.configuration).getConnectionStrengthConnectionsConnectionStrengthGet(requestParameters.user1Id, requestParameters.user2Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Connections
     * @param {ConnectionsApiGetConnectionsConnectionsUserIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConnectionsApi
     */
    public getConnectionsConnectionsUserIdGet(requestParameters: ConnectionsApiGetConnectionsConnectionsUserIdGetRequest, options?: RawAxiosRequestConfig) {
        return ConnectionsApiFp(this.configuration).getConnectionsConnectionsUserIdGet(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get connections for a user at a specific event (admin or data owner)
     * @summary Get Connections For Event
     * @param {ConnectionsApiGetConnectionsForEventConnectionsUserIdEventEventIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConnectionsApi
     */
    public getConnectionsForEventConnectionsUserIdEventEventIdGet(requestParameters: ConnectionsApiGetConnectionsForEventConnectionsUserIdEventEventIdGetRequest, options?: RawAxiosRequestConfig) {
        return ConnectionsApiFp(this.configuration).getConnectionsForEventConnectionsUserIdEventEventIdGet(requestParameters.userId, requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all pending connection requests sent by the user
     * @summary Get Pending Connections
     * @param {ConnectionsApiGetPendingConnectionsConnectionsPendingConnectionsUserIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConnectionsApi
     */
    public getPendingConnectionsConnectionsPendingConnectionsUserIdGet(requestParameters: ConnectionsApiGetPendingConnectionsConnectionsPendingConnectionsUserIdGetRequest, options?: RawAxiosRequestConfig) {
        return ConnectionsApiFp(this.configuration).getPendingConnectionsConnectionsPendingConnectionsUserIdGet(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all unreviewed connection requests received by the user
     * @summary Get Unreviewed Connections
     * @param {ConnectionsApiGetUnreviewedConnectionsConnectionsUnreviewedConnectionsUserIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConnectionsApi
     */
    public getUnreviewedConnectionsConnectionsUnreviewedConnectionsUserIdGet(requestParameters: ConnectionsApiGetUnreviewedConnectionsConnectionsUnreviewedConnectionsUserIdGetRequest, options?: RawAxiosRequestConfig) {
        return ConnectionsApiFp(this.configuration).getUnreviewedConnectionsConnectionsUnreviewedConnectionsUserIdGet(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FollowsApi - axios parameter creator
 * @export
 */
export const FollowsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Follow an entity (person or community) with proper authorization validation
         * @summary Follow Entity
         * @param {FollowsInput} followsInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followEntityFollowsPost: async (followsInput: FollowsInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'followsInput' is not null or undefined
            assertParamExists('followEntityFollowsPost', 'followsInput', followsInput)
            const localVarPath = `/follows/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(followsInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Followers
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFollowersFollowsUserIdFollowersGet: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getFollowersFollowsUserIdFollowersGet', 'userId', userId)
            const localVarPath = `/follows/{user_id}/followers/`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Following
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFollowingFollowsUserIdFollowingGet: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getFollowingFollowsUserIdFollowingGet', 'userId', userId)
            const localVarPath = `/follows/{user_id}/following/`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unfollow an entity (person or community) with proper authorization validation
         * @summary Unfollow Entity
         * @param {FollowsInput} followsInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unfollowEntityFollowsUnfollowPost: async (followsInput: FollowsInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'followsInput' is not null or undefined
            assertParamExists('unfollowEntityFollowsUnfollowPost', 'followsInput', followsInput)
            const localVarPath = `/follows/unfollow/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(followsInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FollowsApi - functional programming interface
 * @export
 */
export const FollowsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FollowsApiAxiosParamCreator(configuration)
    return {
        /**
         * Follow an entity (person or community) with proper authorization validation
         * @summary Follow Entity
         * @param {FollowsInput} followsInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async followEntityFollowsPost(followsInput: FollowsInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FollowableEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.followEntityFollowsPost(followsInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FollowsApi.followEntityFollowsPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Followers
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFollowersFollowsUserIdFollowersGet(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Person>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFollowersFollowsUserIdFollowersGet(userId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FollowsApi.getFollowersFollowsUserIdFollowersGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Following
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFollowingFollowsUserIdFollowingGet(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FollowableEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFollowingFollowsUserIdFollowingGet(userId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FollowsApi.getFollowingFollowsUserIdFollowingGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Unfollow an entity (person or community) with proper authorization validation
         * @summary Unfollow Entity
         * @param {FollowsInput} followsInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unfollowEntityFollowsUnfollowPost(followsInput: FollowsInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FollowableEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unfollowEntityFollowsUnfollowPost(followsInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FollowsApi.unfollowEntityFollowsUnfollowPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * FollowsApi - factory interface
 * @export
 */
export const FollowsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FollowsApiFp(configuration)
    return {
        /**
         * Follow an entity (person or community) with proper authorization validation
         * @summary Follow Entity
         * @param {FollowsApiFollowEntityFollowsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followEntityFollowsPost(requestParameters: FollowsApiFollowEntityFollowsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<FollowableEntity> {
            return localVarFp.followEntityFollowsPost(requestParameters.followsInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Followers
         * @param {FollowsApiGetFollowersFollowsUserIdFollowersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFollowersFollowsUserIdFollowersGet(requestParameters: FollowsApiGetFollowersFollowsUserIdFollowersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Person>> {
            return localVarFp.getFollowersFollowsUserIdFollowersGet(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Following
         * @param {FollowsApiGetFollowingFollowsUserIdFollowingGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFollowingFollowsUserIdFollowingGet(requestParameters: FollowsApiGetFollowingFollowsUserIdFollowingGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<FollowableEntity>> {
            return localVarFp.getFollowingFollowsUserIdFollowingGet(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Unfollow an entity (person or community) with proper authorization validation
         * @summary Unfollow Entity
         * @param {FollowsApiUnfollowEntityFollowsUnfollowPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unfollowEntityFollowsUnfollowPost(requestParameters: FollowsApiUnfollowEntityFollowsUnfollowPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<FollowableEntity> {
            return localVarFp.unfollowEntityFollowsUnfollowPost(requestParameters.followsInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for followEntityFollowsPost operation in FollowsApi.
 * @export
 * @interface FollowsApiFollowEntityFollowsPostRequest
 */
export interface FollowsApiFollowEntityFollowsPostRequest {
    /**
     * 
     * @type {FollowsInput}
     * @memberof FollowsApiFollowEntityFollowsPost
     */
    readonly followsInput: FollowsInput
}

/**
 * Request parameters for getFollowersFollowsUserIdFollowersGet operation in FollowsApi.
 * @export
 * @interface FollowsApiGetFollowersFollowsUserIdFollowersGetRequest
 */
export interface FollowsApiGetFollowersFollowsUserIdFollowersGetRequest {
    /**
     * 
     * @type {string}
     * @memberof FollowsApiGetFollowersFollowsUserIdFollowersGet
     */
    readonly userId: string
}

/**
 * Request parameters for getFollowingFollowsUserIdFollowingGet operation in FollowsApi.
 * @export
 * @interface FollowsApiGetFollowingFollowsUserIdFollowingGetRequest
 */
export interface FollowsApiGetFollowingFollowsUserIdFollowingGetRequest {
    /**
     * 
     * @type {string}
     * @memberof FollowsApiGetFollowingFollowsUserIdFollowingGet
     */
    readonly userId: string
}

/**
 * Request parameters for unfollowEntityFollowsUnfollowPost operation in FollowsApi.
 * @export
 * @interface FollowsApiUnfollowEntityFollowsUnfollowPostRequest
 */
export interface FollowsApiUnfollowEntityFollowsUnfollowPostRequest {
    /**
     * 
     * @type {FollowsInput}
     * @memberof FollowsApiUnfollowEntityFollowsUnfollowPost
     */
    readonly followsInput: FollowsInput
}

/**
 * FollowsApi - object-oriented interface
 * @export
 * @class FollowsApi
 * @extends {BaseAPI}
 */
export class FollowsApi extends BaseAPI {
    /**
     * Follow an entity (person or community) with proper authorization validation
     * @summary Follow Entity
     * @param {FollowsApiFollowEntityFollowsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FollowsApi
     */
    public followEntityFollowsPost(requestParameters: FollowsApiFollowEntityFollowsPostRequest, options?: RawAxiosRequestConfig) {
        return FollowsApiFp(this.configuration).followEntityFollowsPost(requestParameters.followsInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Followers
     * @param {FollowsApiGetFollowersFollowsUserIdFollowersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FollowsApi
     */
    public getFollowersFollowsUserIdFollowersGet(requestParameters: FollowsApiGetFollowersFollowsUserIdFollowersGetRequest, options?: RawAxiosRequestConfig) {
        return FollowsApiFp(this.configuration).getFollowersFollowsUserIdFollowersGet(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Following
     * @param {FollowsApiGetFollowingFollowsUserIdFollowingGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FollowsApi
     */
    public getFollowingFollowsUserIdFollowingGet(requestParameters: FollowsApiGetFollowingFollowsUserIdFollowingGetRequest, options?: RawAxiosRequestConfig) {
        return FollowsApiFp(this.configuration).getFollowingFollowsUserIdFollowingGet(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unfollow an entity (person or community) with proper authorization validation
     * @summary Unfollow Entity
     * @param {FollowsApiUnfollowEntityFollowsUnfollowPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FollowsApi
     */
    public unfollowEntityFollowsUnfollowPost(requestParameters: FollowsApiUnfollowEntityFollowsUnfollowPostRequest, options?: RawAxiosRequestConfig) {
        return FollowsApiFp(this.configuration).unfollowEntityFollowsUnfollowPost(requestParameters.followsInput, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * IntroductionsApi - axios parameter creator
 * @export
 */
export const IntroductionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Acceptor Accept Introduction
         * @param {AcceptIntroInput} acceptIntroInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptorAcceptIntroductionIntroductionsAcceptorAcceptPost: async (acceptIntroInput: AcceptIntroInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'acceptIntroInput' is not null or undefined
            assertParamExists('acceptorAcceptIntroductionIntroductionsAcceptorAcceptPost', 'acceptIntroInput', acceptIntroInput)
            const localVarPath = `/introductions/acceptor/accept/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptIntroInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Denied Introductions
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deniedIntroductionsIntroductionsUserIdDeniedGet: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deniedIntroductionsIntroductionsUserIdDeniedGet', 'userId', userId)
            const localVarPath = `/introductions/{user_id}/denied/`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deny Introduction
         * @param {DenyIntroInput} denyIntroInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        denyIntroductionIntroductionsDenyPost: async (denyIntroInput: DenyIntroInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'denyIntroInput' is not null or undefined
            assertParamExists('denyIntroductionIntroductionsDenyPost', 'denyIntroInput', denyIntroInput)
            const localVarPath = `/introductions/deny/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(denyIntroInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Introduce Users
         * @param {IntroducedToInput} introducedToInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        introduceUsersIntroductionsPost: async (introducedToInput: IntroducedToInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'introducedToInput' is not null or undefined
            assertParamExists('introduceUsersIntroductionsPost', 'introducedToInput', introducedToInput)
            const localVarPath = `/introductions/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(introducedToInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Introducer Accept Introduction
         * @param {IntroducerAcceptIntroInput} introducerAcceptIntroInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        introducerAcceptIntroductionIntroductionsIntroducerAcceptPost: async (introducerAcceptIntroInput: IntroducerAcceptIntroInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'introducerAcceptIntroInput' is not null or undefined
            assertParamExists('introducerAcceptIntroductionIntroductionsIntroducerAcceptPost', 'introducerAcceptIntroInput', introducerAcceptIntroInput)
            const localVarPath = `/introductions/introducer/accept/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(introducerAcceptIntroInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Introduction Count
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        introductionCountIntroductionsUserIdCountGet: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('introductionCountIntroductionsUserIdCountGet', 'userId', userId)
            const localVarPath = `/introductions/{user_id}/count/`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Is Introduced
         * @param {IsIntroducedInput} isIntroducedInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isIntroducedIntroductionsIsIntroducedPost: async (isIntroducedInput: IsIntroducedInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'isIntroducedInput' is not null or undefined
            assertParamExists('isIntroducedIntroductionsIsIntroducedPost', 'isIntroducedInput', isIntroducedInput)
            const localVarPath = `/introductions/is-introduced/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(isIntroducedInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Introductions Made By Me
         * @param {string} userId 
         * @param {IntroductionsByMeStates} state 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listIntroductionsMadeByMeIntroductionsUserIdMadeByMeGet: async (userId: string, state: IntroductionsByMeStates, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('listIntroductionsMadeByMeIntroductionsUserIdMadeByMeGet', 'userId', userId)
            // verify required parameter 'state' is not null or undefined
            assertParamExists('listIntroductionsMadeByMeIntroductionsUserIdMadeByMeGet', 'state', state)
            const localVarPath = `/introductions/{user_id}/made-by-me/`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List My Introductions
         * @param {string} userId 
         * @param {MyIntroductionsStates} state 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyIntroductionsIntroductionsUserIdMyIntroductionsGet: async (userId: string, state: MyIntroductionsStates, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('listMyIntroductionsIntroductionsUserIdMyIntroductionsGet', 'userId', userId)
            // verify required parameter 'state' is not null or undefined
            assertParamExists('listMyIntroductionsIntroductionsUserIdMyIntroductionsGet', 'state', state)
            const localVarPath = `/introductions/{user_id}/my-introductions/`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Requestor Accept Introduction
         * @param {File} file 
         * @param {string} introId A unique identifier (UUID) in hexadecimal format
         * @param {string} userId A unique identifier (UUID) in hexadecimal format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestorAcceptIntroductionIntroductionsRequestorAcceptPost: async (file: File, introId: string, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('requestorAcceptIntroductionIntroductionsRequestorAcceptPost', 'file', file)
            // verify required parameter 'introId' is not null or undefined
            assertParamExists('requestorAcceptIntroductionIntroductionsRequestorAcceptPost', 'introId', introId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('requestorAcceptIntroductionIntroductionsRequestorAcceptPost', 'userId', userId)
            const localVarPath = `/introductions/requestor/accept/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (introId !== undefined) { 
                localVarFormParams.append('intro_id', introId as any);
            }
    
            if (userId !== undefined) { 
                localVarFormParams.append('user_id', userId as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IntroductionsApi - functional programming interface
 * @export
 */
export const IntroductionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IntroductionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Acceptor Accept Introduction
         * @param {AcceptIntroInput} acceptIntroInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptorAcceptIntroductionIntroductionsAcceptorAcceptPost(acceptIntroInput: AcceptIntroInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptorAcceptIntroductionIntroductionsAcceptorAcceptPost(acceptIntroInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['IntroductionsApi.acceptorAcceptIntroductionIntroductionsAcceptorAcceptPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Denied Introductions
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deniedIntroductionsIntroductionsUserIdDeniedGet(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deniedIntroductionsIntroductionsUserIdDeniedGet(userId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['IntroductionsApi.deniedIntroductionsIntroductionsUserIdDeniedGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Deny Introduction
         * @param {DenyIntroInput} denyIntroInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async denyIntroductionIntroductionsDenyPost(denyIntroInput: DenyIntroInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.denyIntroductionIntroductionsDenyPost(denyIntroInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['IntroductionsApi.denyIntroductionIntroductionsDenyPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Introduce Users
         * @param {IntroducedToInput} introducedToInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async introduceUsersIntroductionsPost(introducedToInput: IntroducedToInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Introduction>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.introduceUsersIntroductionsPost(introducedToInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['IntroductionsApi.introduceUsersIntroductionsPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Introducer Accept Introduction
         * @param {IntroducerAcceptIntroInput} introducerAcceptIntroInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async introducerAcceptIntroductionIntroductionsIntroducerAcceptPost(introducerAcceptIntroInput: IntroducerAcceptIntroInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.introducerAcceptIntroductionIntroductionsIntroducerAcceptPost(introducerAcceptIntroInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['IntroductionsApi.introducerAcceptIntroductionIntroductionsIntroducerAcceptPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Introduction Count
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async introductionCountIntroductionsUserIdCountGet(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.introductionCountIntroductionsUserIdCountGet(userId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['IntroductionsApi.introductionCountIntroductionsUserIdCountGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Is Introduced
         * @param {IsIntroducedInput} isIntroducedInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async isIntroducedIntroductionsIsIntroducedPost(isIntroducedInput: IsIntroducedInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IsIntroducedOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.isIntroducedIntroductionsIsIntroducedPost(isIntroducedInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['IntroductionsApi.isIntroducedIntroductionsIsIntroducedPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary List Introductions Made By Me
         * @param {string} userId 
         * @param {IntroductionsByMeStates} state 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listIntroductionsMadeByMeIntroductionsUserIdMadeByMeGet(userId: string, state: IntroductionsByMeStates, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Introduction>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listIntroductionsMadeByMeIntroductionsUserIdMadeByMeGet(userId, state, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['IntroductionsApi.listIntroductionsMadeByMeIntroductionsUserIdMadeByMeGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary List My Introductions
         * @param {string} userId 
         * @param {MyIntroductionsStates} state 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMyIntroductionsIntroductionsUserIdMyIntroductionsGet(userId: string, state: MyIntroductionsStates, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Introduction>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMyIntroductionsIntroductionsUserIdMyIntroductionsGet(userId, state, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['IntroductionsApi.listMyIntroductionsIntroductionsUserIdMyIntroductionsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Requestor Accept Introduction
         * @param {File} file 
         * @param {string} introId A unique identifier (UUID) in hexadecimal format
         * @param {string} userId A unique identifier (UUID) in hexadecimal format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestorAcceptIntroductionIntroductionsRequestorAcceptPost(file: File, introId: string, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestorAcceptIntroductionIntroductionsRequestorAcceptPost(file, introId, userId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['IntroductionsApi.requestorAcceptIntroductionIntroductionsRequestorAcceptPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * IntroductionsApi - factory interface
 * @export
 */
export const IntroductionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IntroductionsApiFp(configuration)
    return {
        /**
         * 
         * @summary Acceptor Accept Introduction
         * @param {IntroductionsApiAcceptorAcceptIntroductionIntroductionsAcceptorAcceptPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptorAcceptIntroductionIntroductionsAcceptorAcceptPost(requestParameters: IntroductionsApiAcceptorAcceptIntroductionIntroductionsAcceptorAcceptPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.acceptorAcceptIntroductionIntroductionsAcceptorAcceptPost(requestParameters.acceptIntroInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Denied Introductions
         * @param {IntroductionsApiDeniedIntroductionsIntroductionsUserIdDeniedGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deniedIntroductionsIntroductionsUserIdDeniedGet(requestParameters: IntroductionsApiDeniedIntroductionsIntroductionsUserIdDeniedGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deniedIntroductionsIntroductionsUserIdDeniedGet(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deny Introduction
         * @param {IntroductionsApiDenyIntroductionIntroductionsDenyPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        denyIntroductionIntroductionsDenyPost(requestParameters: IntroductionsApiDenyIntroductionIntroductionsDenyPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.denyIntroductionIntroductionsDenyPost(requestParameters.denyIntroInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Introduce Users
         * @param {IntroductionsApiIntroduceUsersIntroductionsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        introduceUsersIntroductionsPost(requestParameters: IntroductionsApiIntroduceUsersIntroductionsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Introduction> {
            return localVarFp.introduceUsersIntroductionsPost(requestParameters.introducedToInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Introducer Accept Introduction
         * @param {IntroductionsApiIntroducerAcceptIntroductionIntroductionsIntroducerAcceptPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        introducerAcceptIntroductionIntroductionsIntroducerAcceptPost(requestParameters: IntroductionsApiIntroducerAcceptIntroductionIntroductionsIntroducerAcceptPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.introducerAcceptIntroductionIntroductionsIntroducerAcceptPost(requestParameters.introducerAcceptIntroInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Introduction Count
         * @param {IntroductionsApiIntroductionCountIntroductionsUserIdCountGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        introductionCountIntroductionsUserIdCountGet(requestParameters: IntroductionsApiIntroductionCountIntroductionsUserIdCountGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.introductionCountIntroductionsUserIdCountGet(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Is Introduced
         * @param {IntroductionsApiIsIntroducedIntroductionsIsIntroducedPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isIntroducedIntroductionsIsIntroducedPost(requestParameters: IntroductionsApiIsIntroducedIntroductionsIsIntroducedPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<IsIntroducedOutput> {
            return localVarFp.isIntroducedIntroductionsIsIntroducedPost(requestParameters.isIntroducedInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Introductions Made By Me
         * @param {IntroductionsApiListIntroductionsMadeByMeIntroductionsUserIdMadeByMeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listIntroductionsMadeByMeIntroductionsUserIdMadeByMeGet(requestParameters: IntroductionsApiListIntroductionsMadeByMeIntroductionsUserIdMadeByMeGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Introduction>> {
            return localVarFp.listIntroductionsMadeByMeIntroductionsUserIdMadeByMeGet(requestParameters.userId, requestParameters.state, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List My Introductions
         * @param {IntroductionsApiListMyIntroductionsIntroductionsUserIdMyIntroductionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyIntroductionsIntroductionsUserIdMyIntroductionsGet(requestParameters: IntroductionsApiListMyIntroductionsIntroductionsUserIdMyIntroductionsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Introduction>> {
            return localVarFp.listMyIntroductionsIntroductionsUserIdMyIntroductionsGet(requestParameters.userId, requestParameters.state, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Requestor Accept Introduction
         * @param {IntroductionsApiRequestorAcceptIntroductionIntroductionsRequestorAcceptPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestorAcceptIntroductionIntroductionsRequestorAcceptPost(requestParameters: IntroductionsApiRequestorAcceptIntroductionIntroductionsRequestorAcceptPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.requestorAcceptIntroductionIntroductionsRequestorAcceptPost(requestParameters.file, requestParameters.introId, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for acceptorAcceptIntroductionIntroductionsAcceptorAcceptPost operation in IntroductionsApi.
 * @export
 * @interface IntroductionsApiAcceptorAcceptIntroductionIntroductionsAcceptorAcceptPostRequest
 */
export interface IntroductionsApiAcceptorAcceptIntroductionIntroductionsAcceptorAcceptPostRequest {
    /**
     * 
     * @type {AcceptIntroInput}
     * @memberof IntroductionsApiAcceptorAcceptIntroductionIntroductionsAcceptorAcceptPost
     */
    readonly acceptIntroInput: AcceptIntroInput
}

/**
 * Request parameters for deniedIntroductionsIntroductionsUserIdDeniedGet operation in IntroductionsApi.
 * @export
 * @interface IntroductionsApiDeniedIntroductionsIntroductionsUserIdDeniedGetRequest
 */
export interface IntroductionsApiDeniedIntroductionsIntroductionsUserIdDeniedGetRequest {
    /**
     * 
     * @type {string}
     * @memberof IntroductionsApiDeniedIntroductionsIntroductionsUserIdDeniedGet
     */
    readonly userId: string
}

/**
 * Request parameters for denyIntroductionIntroductionsDenyPost operation in IntroductionsApi.
 * @export
 * @interface IntroductionsApiDenyIntroductionIntroductionsDenyPostRequest
 */
export interface IntroductionsApiDenyIntroductionIntroductionsDenyPostRequest {
    /**
     * 
     * @type {DenyIntroInput}
     * @memberof IntroductionsApiDenyIntroductionIntroductionsDenyPost
     */
    readonly denyIntroInput: DenyIntroInput
}

/**
 * Request parameters for introduceUsersIntroductionsPost operation in IntroductionsApi.
 * @export
 * @interface IntroductionsApiIntroduceUsersIntroductionsPostRequest
 */
export interface IntroductionsApiIntroduceUsersIntroductionsPostRequest {
    /**
     * 
     * @type {IntroducedToInput}
     * @memberof IntroductionsApiIntroduceUsersIntroductionsPost
     */
    readonly introducedToInput: IntroducedToInput
}

/**
 * Request parameters for introducerAcceptIntroductionIntroductionsIntroducerAcceptPost operation in IntroductionsApi.
 * @export
 * @interface IntroductionsApiIntroducerAcceptIntroductionIntroductionsIntroducerAcceptPostRequest
 */
export interface IntroductionsApiIntroducerAcceptIntroductionIntroductionsIntroducerAcceptPostRequest {
    /**
     * 
     * @type {IntroducerAcceptIntroInput}
     * @memberof IntroductionsApiIntroducerAcceptIntroductionIntroductionsIntroducerAcceptPost
     */
    readonly introducerAcceptIntroInput: IntroducerAcceptIntroInput
}

/**
 * Request parameters for introductionCountIntroductionsUserIdCountGet operation in IntroductionsApi.
 * @export
 * @interface IntroductionsApiIntroductionCountIntroductionsUserIdCountGetRequest
 */
export interface IntroductionsApiIntroductionCountIntroductionsUserIdCountGetRequest {
    /**
     * 
     * @type {string}
     * @memberof IntroductionsApiIntroductionCountIntroductionsUserIdCountGet
     */
    readonly userId: string
}

/**
 * Request parameters for isIntroducedIntroductionsIsIntroducedPost operation in IntroductionsApi.
 * @export
 * @interface IntroductionsApiIsIntroducedIntroductionsIsIntroducedPostRequest
 */
export interface IntroductionsApiIsIntroducedIntroductionsIsIntroducedPostRequest {
    /**
     * 
     * @type {IsIntroducedInput}
     * @memberof IntroductionsApiIsIntroducedIntroductionsIsIntroducedPost
     */
    readonly isIntroducedInput: IsIntroducedInput
}

/**
 * Request parameters for listIntroductionsMadeByMeIntroductionsUserIdMadeByMeGet operation in IntroductionsApi.
 * @export
 * @interface IntroductionsApiListIntroductionsMadeByMeIntroductionsUserIdMadeByMeGetRequest
 */
export interface IntroductionsApiListIntroductionsMadeByMeIntroductionsUserIdMadeByMeGetRequest {
    /**
     * 
     * @type {string}
     * @memberof IntroductionsApiListIntroductionsMadeByMeIntroductionsUserIdMadeByMeGet
     */
    readonly userId: string

    /**
     * 
     * @type {IntroductionsByMeStates}
     * @memberof IntroductionsApiListIntroductionsMadeByMeIntroductionsUserIdMadeByMeGet
     */
    readonly state: IntroductionsByMeStates
}

/**
 * Request parameters for listMyIntroductionsIntroductionsUserIdMyIntroductionsGet operation in IntroductionsApi.
 * @export
 * @interface IntroductionsApiListMyIntroductionsIntroductionsUserIdMyIntroductionsGetRequest
 */
export interface IntroductionsApiListMyIntroductionsIntroductionsUserIdMyIntroductionsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof IntroductionsApiListMyIntroductionsIntroductionsUserIdMyIntroductionsGet
     */
    readonly userId: string

    /**
     * 
     * @type {MyIntroductionsStates}
     * @memberof IntroductionsApiListMyIntroductionsIntroductionsUserIdMyIntroductionsGet
     */
    readonly state: MyIntroductionsStates
}

/**
 * Request parameters for requestorAcceptIntroductionIntroductionsRequestorAcceptPost operation in IntroductionsApi.
 * @export
 * @interface IntroductionsApiRequestorAcceptIntroductionIntroductionsRequestorAcceptPostRequest
 */
export interface IntroductionsApiRequestorAcceptIntroductionIntroductionsRequestorAcceptPostRequest {
    /**
     * 
     * @type {File}
     * @memberof IntroductionsApiRequestorAcceptIntroductionIntroductionsRequestorAcceptPost
     */
    readonly file: File

    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof IntroductionsApiRequestorAcceptIntroductionIntroductionsRequestorAcceptPost
     */
    readonly introId: string

    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof IntroductionsApiRequestorAcceptIntroductionIntroductionsRequestorAcceptPost
     */
    readonly userId: string
}

/**
 * IntroductionsApi - object-oriented interface
 * @export
 * @class IntroductionsApi
 * @extends {BaseAPI}
 */
export class IntroductionsApi extends BaseAPI {
    /**
     * 
     * @summary Acceptor Accept Introduction
     * @param {IntroductionsApiAcceptorAcceptIntroductionIntroductionsAcceptorAcceptPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntroductionsApi
     */
    public acceptorAcceptIntroductionIntroductionsAcceptorAcceptPost(requestParameters: IntroductionsApiAcceptorAcceptIntroductionIntroductionsAcceptorAcceptPostRequest, options?: RawAxiosRequestConfig) {
        return IntroductionsApiFp(this.configuration).acceptorAcceptIntroductionIntroductionsAcceptorAcceptPost(requestParameters.acceptIntroInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Denied Introductions
     * @param {IntroductionsApiDeniedIntroductionsIntroductionsUserIdDeniedGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntroductionsApi
     */
    public deniedIntroductionsIntroductionsUserIdDeniedGet(requestParameters: IntroductionsApiDeniedIntroductionsIntroductionsUserIdDeniedGetRequest, options?: RawAxiosRequestConfig) {
        return IntroductionsApiFp(this.configuration).deniedIntroductionsIntroductionsUserIdDeniedGet(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deny Introduction
     * @param {IntroductionsApiDenyIntroductionIntroductionsDenyPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntroductionsApi
     */
    public denyIntroductionIntroductionsDenyPost(requestParameters: IntroductionsApiDenyIntroductionIntroductionsDenyPostRequest, options?: RawAxiosRequestConfig) {
        return IntroductionsApiFp(this.configuration).denyIntroductionIntroductionsDenyPost(requestParameters.denyIntroInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Introduce Users
     * @param {IntroductionsApiIntroduceUsersIntroductionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntroductionsApi
     */
    public introduceUsersIntroductionsPost(requestParameters: IntroductionsApiIntroduceUsersIntroductionsPostRequest, options?: RawAxiosRequestConfig) {
        return IntroductionsApiFp(this.configuration).introduceUsersIntroductionsPost(requestParameters.introducedToInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Introducer Accept Introduction
     * @param {IntroductionsApiIntroducerAcceptIntroductionIntroductionsIntroducerAcceptPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntroductionsApi
     */
    public introducerAcceptIntroductionIntroductionsIntroducerAcceptPost(requestParameters: IntroductionsApiIntroducerAcceptIntroductionIntroductionsIntroducerAcceptPostRequest, options?: RawAxiosRequestConfig) {
        return IntroductionsApiFp(this.configuration).introducerAcceptIntroductionIntroductionsIntroducerAcceptPost(requestParameters.introducerAcceptIntroInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Introduction Count
     * @param {IntroductionsApiIntroductionCountIntroductionsUserIdCountGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntroductionsApi
     */
    public introductionCountIntroductionsUserIdCountGet(requestParameters: IntroductionsApiIntroductionCountIntroductionsUserIdCountGetRequest, options?: RawAxiosRequestConfig) {
        return IntroductionsApiFp(this.configuration).introductionCountIntroductionsUserIdCountGet(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Is Introduced
     * @param {IntroductionsApiIsIntroducedIntroductionsIsIntroducedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntroductionsApi
     */
    public isIntroducedIntroductionsIsIntroducedPost(requestParameters: IntroductionsApiIsIntroducedIntroductionsIsIntroducedPostRequest, options?: RawAxiosRequestConfig) {
        return IntroductionsApiFp(this.configuration).isIntroducedIntroductionsIsIntroducedPost(requestParameters.isIntroducedInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Introductions Made By Me
     * @param {IntroductionsApiListIntroductionsMadeByMeIntroductionsUserIdMadeByMeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntroductionsApi
     */
    public listIntroductionsMadeByMeIntroductionsUserIdMadeByMeGet(requestParameters: IntroductionsApiListIntroductionsMadeByMeIntroductionsUserIdMadeByMeGetRequest, options?: RawAxiosRequestConfig) {
        return IntroductionsApiFp(this.configuration).listIntroductionsMadeByMeIntroductionsUserIdMadeByMeGet(requestParameters.userId, requestParameters.state, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List My Introductions
     * @param {IntroductionsApiListMyIntroductionsIntroductionsUserIdMyIntroductionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntroductionsApi
     */
    public listMyIntroductionsIntroductionsUserIdMyIntroductionsGet(requestParameters: IntroductionsApiListMyIntroductionsIntroductionsUserIdMyIntroductionsGetRequest, options?: RawAxiosRequestConfig) {
        return IntroductionsApiFp(this.configuration).listMyIntroductionsIntroductionsUserIdMyIntroductionsGet(requestParameters.userId, requestParameters.state, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Requestor Accept Introduction
     * @param {IntroductionsApiRequestorAcceptIntroductionIntroductionsRequestorAcceptPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntroductionsApi
     */
    public requestorAcceptIntroductionIntroductionsRequestorAcceptPost(requestParameters: IntroductionsApiRequestorAcceptIntroductionIntroductionsRequestorAcceptPostRequest, options?: RawAxiosRequestConfig) {
        return IntroductionsApiFp(this.configuration).requestorAcceptIntroductionIntroductionsRequestorAcceptPost(requestParameters.file, requestParameters.introId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MembershipsApi - axios parameter creator
 * @export
 */
export const MembershipsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Check if a person is a member of a community (admin or data owner)
         * @summary Check Membership Status
         * @param {string} userId 
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkMembershipStatusMembershipsCheckUserIdCommunitiesCommunityIdGet: async (userId: string, communityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('checkMembershipStatusMembershipsCheckUserIdCommunitiesCommunityIdGet', 'userId', userId)
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('checkMembershipStatusMembershipsCheckUserIdCommunitiesCommunityIdGet', 'communityId', communityId)
            const localVarPath = `/memberships/check/{user_id}/communities/{community_id}/`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get count of community members
         * @summary Get Community Member Count
         * @param {string} communityId 
         * @param {boolean} [isActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommunityMemberCountMembershipsCommunitiesCommunityIdCountGet: async (communityId: string, isActive?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('getCommunityMemberCountMembershipsCommunitiesCommunityIdCountGet', 'communityId', communityId)
            const localVarPath = `/memberships/communities/{community_id}/count/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (isActive !== undefined) {
                localVarQueryParameter['is_active'] = isActive;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get members of a community
         * @summary Get Community Members
         * @param {string} communityId 
         * @param {boolean} [isActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommunityMembersMembershipsCommunitiesCommunityIdMembersGet: async (communityId: string, isActive?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('getCommunityMembersMembershipsCommunitiesCommunityIdMembersGet', 'communityId', communityId)
            const localVarPath = `/memberships/communities/{community_id}/members/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isActive !== undefined) {
                localVarQueryParameter['is_active'] = isActive;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get organizers of a community (public endpoint)
         * @summary Get Community Organizers
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommunityOrganizersMembershipsCommunitiesCommunityIdOrganizersGet: async (communityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('getCommunityOrganizersMembershipsCommunitiesCommunityIdOrganizersGet', 'communityId', communityId)
            const localVarPath = `/memberships/communities/{community_id}/organizers/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get count of user\'s memberships
         * @summary Get My Membership Count
         * @param {boolean} [isActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyMembershipCountMembershipsCountGet: async (isActive?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/memberships/count/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isActive !== undefined) {
                localVarQueryParameter['is_active'] = isActive;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get user\'s memberships
         * @summary Get My Memberships
         * @param {boolean} [isActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyMembershipsMembershipsMyMembershipsGet: async (isActive?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/memberships/my-memberships/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isActive !== undefined) {
                localVarQueryParameter['is_active'] = isActive;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Join a community
         * @summary Join Community
         * @param {JoinCommunityInput} joinCommunityInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinCommunityMembershipsJoinPost: async (joinCommunityInput: JoinCommunityInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'joinCommunityInput' is not null or undefined
            assertParamExists('joinCommunityMembershipsJoinPost', 'joinCommunityInput', joinCommunityInput)
            const localVarPath = `/memberships/join/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(joinCommunityInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Leave a community
         * @summary Leave Community
         * @param {LeaveCommunityInput} leaveCommunityInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaveCommunityMembershipsLeavePost: async (leaveCommunityInput: LeaveCommunityInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'leaveCommunityInput' is not null or undefined
            assertParamExists('leaveCommunityMembershipsLeavePost', 'leaveCommunityInput', leaveCommunityInput)
            const localVarPath = `/memberships/leave/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(leaveCommunityInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove organizer status from your own membership
         * @summary Remove Own Organizer Status
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeOwnOrganizerStatusMembershipsCommunitiesCommunityIdRemoveMyOrganizerStatusPatch: async (communityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('removeOwnOrganizerStatusMembershipsCommunitiesCommunityIdRemoveMyOrganizerStatusPatch', 'communityId', communityId)
            const localVarPath = `/memberships/communities/{community_id}/remove-my-organizer-status/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a member\'s organizer status (requires OWNER or EDITOR role)
         * @summary Update Member Organizer Status
         * @param {string} communityId 
         * @param {string} userId 
         * @param {UpdateMemberOrganizerStatusInput} updateMemberOrganizerStatusInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMemberOrganizerStatusMembershipsCommunitiesCommunityIdMembersUserIdOrganizerStatusPatch: async (communityId: string, userId: string, updateMemberOrganizerStatusInput: UpdateMemberOrganizerStatusInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('updateMemberOrganizerStatusMembershipsCommunitiesCommunityIdMembersUserIdOrganizerStatusPatch', 'communityId', communityId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateMemberOrganizerStatusMembershipsCommunitiesCommunityIdMembersUserIdOrganizerStatusPatch', 'userId', userId)
            // verify required parameter 'updateMemberOrganizerStatusInput' is not null or undefined
            assertParamExists('updateMemberOrganizerStatusMembershipsCommunitiesCommunityIdMembersUserIdOrganizerStatusPatch', 'updateMemberOrganizerStatusInput', updateMemberOrganizerStatusInput)
            const localVarPath = `/memberships/communities/{community_id}/members/{user_id}/organizer-status/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMemberOrganizerStatusInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MembershipsApi - functional programming interface
 * @export
 */
export const MembershipsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MembershipsApiAxiosParamCreator(configuration)
    return {
        /**
         * Check if a person is a member of a community (admin or data owner)
         * @summary Check Membership Status
         * @param {string} userId 
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkMembershipStatusMembershipsCheckUserIdCommunitiesCommunityIdGet(userId: string, communityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IsMemberOfOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkMembershipStatusMembershipsCheckUserIdCommunitiesCommunityIdGet(userId, communityId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MembershipsApi.checkMembershipStatusMembershipsCheckUserIdCommunitiesCommunityIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get count of community members
         * @summary Get Community Member Count
         * @param {string} communityId 
         * @param {boolean} [isActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommunityMemberCountMembershipsCommunitiesCommunityIdCountGet(communityId: string, isActive?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MembershipCountOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommunityMemberCountMembershipsCommunitiesCommunityIdCountGet(communityId, isActive, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MembershipsApi.getCommunityMemberCountMembershipsCommunitiesCommunityIdCountGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get members of a community
         * @summary Get Community Members
         * @param {string} communityId 
         * @param {boolean} [isActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommunityMembersMembershipsCommunitiesCommunityIdMembersGet(communityId: string, isActive?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MemberOutput>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommunityMembersMembershipsCommunitiesCommunityIdMembersGet(communityId, isActive, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MembershipsApi.getCommunityMembersMembershipsCommunitiesCommunityIdMembersGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get organizers of a community (public endpoint)
         * @summary Get Community Organizers
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommunityOrganizersMembershipsCommunitiesCommunityIdOrganizersGet(communityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CommunityOrganizerOutput>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommunityOrganizersMembershipsCommunitiesCommunityIdOrganizersGet(communityId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MembershipsApi.getCommunityOrganizersMembershipsCommunitiesCommunityIdOrganizersGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get count of user\'s memberships
         * @summary Get My Membership Count
         * @param {boolean} [isActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyMembershipCountMembershipsCountGet(isActive?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MembershipCountOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyMembershipCountMembershipsCountGet(isActive, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MembershipsApi.getMyMembershipCountMembershipsCountGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get user\'s memberships
         * @summary Get My Memberships
         * @param {boolean} [isActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyMembershipsMembershipsMyMembershipsGet(isActive?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MembershipOutput>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyMembershipsMembershipsMyMembershipsGet(isActive, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MembershipsApi.getMyMembershipsMembershipsMyMembershipsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Join a community
         * @summary Join Community
         * @param {JoinCommunityInput} joinCommunityInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async joinCommunityMembershipsJoinPost(joinCommunityInput: JoinCommunityInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JoinCommunityOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.joinCommunityMembershipsJoinPost(joinCommunityInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MembershipsApi.joinCommunityMembershipsJoinPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Leave a community
         * @summary Leave Community
         * @param {LeaveCommunityInput} leaveCommunityInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async leaveCommunityMembershipsLeavePost(leaveCommunityInput: LeaveCommunityInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LeaveCommunityOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.leaveCommunityMembershipsLeavePost(leaveCommunityInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MembershipsApi.leaveCommunityMembershipsLeavePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Remove organizer status from your own membership
         * @summary Remove Own Organizer Status
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeOwnOrganizerStatusMembershipsCommunitiesCommunityIdRemoveMyOrganizerStatusPatch(communityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateMemberOrganizerStatusOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeOwnOrganizerStatusMembershipsCommunitiesCommunityIdRemoveMyOrganizerStatusPatch(communityId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MembershipsApi.removeOwnOrganizerStatusMembershipsCommunitiesCommunityIdRemoveMyOrganizerStatusPatch']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Update a member\'s organizer status (requires OWNER or EDITOR role)
         * @summary Update Member Organizer Status
         * @param {string} communityId 
         * @param {string} userId 
         * @param {UpdateMemberOrganizerStatusInput} updateMemberOrganizerStatusInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMemberOrganizerStatusMembershipsCommunitiesCommunityIdMembersUserIdOrganizerStatusPatch(communityId: string, userId: string, updateMemberOrganizerStatusInput: UpdateMemberOrganizerStatusInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateMemberOrganizerStatusOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMemberOrganizerStatusMembershipsCommunitiesCommunityIdMembersUserIdOrganizerStatusPatch(communityId, userId, updateMemberOrganizerStatusInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MembershipsApi.updateMemberOrganizerStatusMembershipsCommunitiesCommunityIdMembersUserIdOrganizerStatusPatch']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * MembershipsApi - factory interface
 * @export
 */
export const MembershipsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MembershipsApiFp(configuration)
    return {
        /**
         * Check if a person is a member of a community (admin or data owner)
         * @summary Check Membership Status
         * @param {MembershipsApiCheckMembershipStatusMembershipsCheckUserIdCommunitiesCommunityIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkMembershipStatusMembershipsCheckUserIdCommunitiesCommunityIdGet(requestParameters: MembershipsApiCheckMembershipStatusMembershipsCheckUserIdCommunitiesCommunityIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<IsMemberOfOutput> {
            return localVarFp.checkMembershipStatusMembershipsCheckUserIdCommunitiesCommunityIdGet(requestParameters.userId, requestParameters.communityId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get count of community members
         * @summary Get Community Member Count
         * @param {MembershipsApiGetCommunityMemberCountMembershipsCommunitiesCommunityIdCountGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommunityMemberCountMembershipsCommunitiesCommunityIdCountGet(requestParameters: MembershipsApiGetCommunityMemberCountMembershipsCommunitiesCommunityIdCountGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<MembershipCountOutput> {
            return localVarFp.getCommunityMemberCountMembershipsCommunitiesCommunityIdCountGet(requestParameters.communityId, requestParameters.isActive, options).then((request) => request(axios, basePath));
        },
        /**
         * Get members of a community
         * @summary Get Community Members
         * @param {MembershipsApiGetCommunityMembersMembershipsCommunitiesCommunityIdMembersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommunityMembersMembershipsCommunitiesCommunityIdMembersGet(requestParameters: MembershipsApiGetCommunityMembersMembershipsCommunitiesCommunityIdMembersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<MemberOutput>> {
            return localVarFp.getCommunityMembersMembershipsCommunitiesCommunityIdMembersGet(requestParameters.communityId, requestParameters.isActive, options).then((request) => request(axios, basePath));
        },
        /**
         * Get organizers of a community (public endpoint)
         * @summary Get Community Organizers
         * @param {MembershipsApiGetCommunityOrganizersMembershipsCommunitiesCommunityIdOrganizersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommunityOrganizersMembershipsCommunitiesCommunityIdOrganizersGet(requestParameters: MembershipsApiGetCommunityOrganizersMembershipsCommunitiesCommunityIdOrganizersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<CommunityOrganizerOutput>> {
            return localVarFp.getCommunityOrganizersMembershipsCommunitiesCommunityIdOrganizersGet(requestParameters.communityId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get count of user\'s memberships
         * @summary Get My Membership Count
         * @param {MembershipsApiGetMyMembershipCountMembershipsCountGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyMembershipCountMembershipsCountGet(requestParameters: MembershipsApiGetMyMembershipCountMembershipsCountGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<MembershipCountOutput> {
            return localVarFp.getMyMembershipCountMembershipsCountGet(requestParameters.isActive, options).then((request) => request(axios, basePath));
        },
        /**
         * Get user\'s memberships
         * @summary Get My Memberships
         * @param {MembershipsApiGetMyMembershipsMembershipsMyMembershipsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyMembershipsMembershipsMyMembershipsGet(requestParameters: MembershipsApiGetMyMembershipsMembershipsMyMembershipsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<MembershipOutput>> {
            return localVarFp.getMyMembershipsMembershipsMyMembershipsGet(requestParameters.isActive, options).then((request) => request(axios, basePath));
        },
        /**
         * Join a community
         * @summary Join Community
         * @param {MembershipsApiJoinCommunityMembershipsJoinPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinCommunityMembershipsJoinPost(requestParameters: MembershipsApiJoinCommunityMembershipsJoinPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<JoinCommunityOutput> {
            return localVarFp.joinCommunityMembershipsJoinPost(requestParameters.joinCommunityInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Leave a community
         * @summary Leave Community
         * @param {MembershipsApiLeaveCommunityMembershipsLeavePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaveCommunityMembershipsLeavePost(requestParameters: MembershipsApiLeaveCommunityMembershipsLeavePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<LeaveCommunityOutput> {
            return localVarFp.leaveCommunityMembershipsLeavePost(requestParameters.leaveCommunityInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove organizer status from your own membership
         * @summary Remove Own Organizer Status
         * @param {MembershipsApiRemoveOwnOrganizerStatusMembershipsCommunitiesCommunityIdRemoveMyOrganizerStatusPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeOwnOrganizerStatusMembershipsCommunitiesCommunityIdRemoveMyOrganizerStatusPatch(requestParameters: MembershipsApiRemoveOwnOrganizerStatusMembershipsCommunitiesCommunityIdRemoveMyOrganizerStatusPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateMemberOrganizerStatusOutput> {
            return localVarFp.removeOwnOrganizerStatusMembershipsCommunitiesCommunityIdRemoveMyOrganizerStatusPatch(requestParameters.communityId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a member\'s organizer status (requires OWNER or EDITOR role)
         * @summary Update Member Organizer Status
         * @param {MembershipsApiUpdateMemberOrganizerStatusMembershipsCommunitiesCommunityIdMembersUserIdOrganizerStatusPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMemberOrganizerStatusMembershipsCommunitiesCommunityIdMembersUserIdOrganizerStatusPatch(requestParameters: MembershipsApiUpdateMemberOrganizerStatusMembershipsCommunitiesCommunityIdMembersUserIdOrganizerStatusPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateMemberOrganizerStatusOutput> {
            return localVarFp.updateMemberOrganizerStatusMembershipsCommunitiesCommunityIdMembersUserIdOrganizerStatusPatch(requestParameters.communityId, requestParameters.userId, requestParameters.updateMemberOrganizerStatusInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for checkMembershipStatusMembershipsCheckUserIdCommunitiesCommunityIdGet operation in MembershipsApi.
 * @export
 * @interface MembershipsApiCheckMembershipStatusMembershipsCheckUserIdCommunitiesCommunityIdGetRequest
 */
export interface MembershipsApiCheckMembershipStatusMembershipsCheckUserIdCommunitiesCommunityIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof MembershipsApiCheckMembershipStatusMembershipsCheckUserIdCommunitiesCommunityIdGet
     */
    readonly userId: string

    /**
     * 
     * @type {string}
     * @memberof MembershipsApiCheckMembershipStatusMembershipsCheckUserIdCommunitiesCommunityIdGet
     */
    readonly communityId: string
}

/**
 * Request parameters for getCommunityMemberCountMembershipsCommunitiesCommunityIdCountGet operation in MembershipsApi.
 * @export
 * @interface MembershipsApiGetCommunityMemberCountMembershipsCommunitiesCommunityIdCountGetRequest
 */
export interface MembershipsApiGetCommunityMemberCountMembershipsCommunitiesCommunityIdCountGetRequest {
    /**
     * 
     * @type {string}
     * @memberof MembershipsApiGetCommunityMemberCountMembershipsCommunitiesCommunityIdCountGet
     */
    readonly communityId: string

    /**
     * 
     * @type {boolean}
     * @memberof MembershipsApiGetCommunityMemberCountMembershipsCommunitiesCommunityIdCountGet
     */
    readonly isActive?: boolean
}

/**
 * Request parameters for getCommunityMembersMembershipsCommunitiesCommunityIdMembersGet operation in MembershipsApi.
 * @export
 * @interface MembershipsApiGetCommunityMembersMembershipsCommunitiesCommunityIdMembersGetRequest
 */
export interface MembershipsApiGetCommunityMembersMembershipsCommunitiesCommunityIdMembersGetRequest {
    /**
     * 
     * @type {string}
     * @memberof MembershipsApiGetCommunityMembersMembershipsCommunitiesCommunityIdMembersGet
     */
    readonly communityId: string

    /**
     * 
     * @type {boolean}
     * @memberof MembershipsApiGetCommunityMembersMembershipsCommunitiesCommunityIdMembersGet
     */
    readonly isActive?: boolean
}

/**
 * Request parameters for getCommunityOrganizersMembershipsCommunitiesCommunityIdOrganizersGet operation in MembershipsApi.
 * @export
 * @interface MembershipsApiGetCommunityOrganizersMembershipsCommunitiesCommunityIdOrganizersGetRequest
 */
export interface MembershipsApiGetCommunityOrganizersMembershipsCommunitiesCommunityIdOrganizersGetRequest {
    /**
     * 
     * @type {string}
     * @memberof MembershipsApiGetCommunityOrganizersMembershipsCommunitiesCommunityIdOrganizersGet
     */
    readonly communityId: string
}

/**
 * Request parameters for getMyMembershipCountMembershipsCountGet operation in MembershipsApi.
 * @export
 * @interface MembershipsApiGetMyMembershipCountMembershipsCountGetRequest
 */
export interface MembershipsApiGetMyMembershipCountMembershipsCountGetRequest {
    /**
     * 
     * @type {boolean}
     * @memberof MembershipsApiGetMyMembershipCountMembershipsCountGet
     */
    readonly isActive?: boolean
}

/**
 * Request parameters for getMyMembershipsMembershipsMyMembershipsGet operation in MembershipsApi.
 * @export
 * @interface MembershipsApiGetMyMembershipsMembershipsMyMembershipsGetRequest
 */
export interface MembershipsApiGetMyMembershipsMembershipsMyMembershipsGetRequest {
    /**
     * 
     * @type {boolean}
     * @memberof MembershipsApiGetMyMembershipsMembershipsMyMembershipsGet
     */
    readonly isActive?: boolean
}

/**
 * Request parameters for joinCommunityMembershipsJoinPost operation in MembershipsApi.
 * @export
 * @interface MembershipsApiJoinCommunityMembershipsJoinPostRequest
 */
export interface MembershipsApiJoinCommunityMembershipsJoinPostRequest {
    /**
     * 
     * @type {JoinCommunityInput}
     * @memberof MembershipsApiJoinCommunityMembershipsJoinPost
     */
    readonly joinCommunityInput: JoinCommunityInput
}

/**
 * Request parameters for leaveCommunityMembershipsLeavePost operation in MembershipsApi.
 * @export
 * @interface MembershipsApiLeaveCommunityMembershipsLeavePostRequest
 */
export interface MembershipsApiLeaveCommunityMembershipsLeavePostRequest {
    /**
     * 
     * @type {LeaveCommunityInput}
     * @memberof MembershipsApiLeaveCommunityMembershipsLeavePost
     */
    readonly leaveCommunityInput: LeaveCommunityInput
}

/**
 * Request parameters for removeOwnOrganizerStatusMembershipsCommunitiesCommunityIdRemoveMyOrganizerStatusPatch operation in MembershipsApi.
 * @export
 * @interface MembershipsApiRemoveOwnOrganizerStatusMembershipsCommunitiesCommunityIdRemoveMyOrganizerStatusPatchRequest
 */
export interface MembershipsApiRemoveOwnOrganizerStatusMembershipsCommunitiesCommunityIdRemoveMyOrganizerStatusPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof MembershipsApiRemoveOwnOrganizerStatusMembershipsCommunitiesCommunityIdRemoveMyOrganizerStatusPatch
     */
    readonly communityId: string
}

/**
 * Request parameters for updateMemberOrganizerStatusMembershipsCommunitiesCommunityIdMembersUserIdOrganizerStatusPatch operation in MembershipsApi.
 * @export
 * @interface MembershipsApiUpdateMemberOrganizerStatusMembershipsCommunitiesCommunityIdMembersUserIdOrganizerStatusPatchRequest
 */
export interface MembershipsApiUpdateMemberOrganizerStatusMembershipsCommunitiesCommunityIdMembersUserIdOrganizerStatusPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof MembershipsApiUpdateMemberOrganizerStatusMembershipsCommunitiesCommunityIdMembersUserIdOrganizerStatusPatch
     */
    readonly communityId: string

    /**
     * 
     * @type {string}
     * @memberof MembershipsApiUpdateMemberOrganizerStatusMembershipsCommunitiesCommunityIdMembersUserIdOrganizerStatusPatch
     */
    readonly userId: string

    /**
     * 
     * @type {UpdateMemberOrganizerStatusInput}
     * @memberof MembershipsApiUpdateMemberOrganizerStatusMembershipsCommunitiesCommunityIdMembersUserIdOrganizerStatusPatch
     */
    readonly updateMemberOrganizerStatusInput: UpdateMemberOrganizerStatusInput
}

/**
 * MembershipsApi - object-oriented interface
 * @export
 * @class MembershipsApi
 * @extends {BaseAPI}
 */
export class MembershipsApi extends BaseAPI {
    /**
     * Check if a person is a member of a community (admin or data owner)
     * @summary Check Membership Status
     * @param {MembershipsApiCheckMembershipStatusMembershipsCheckUserIdCommunitiesCommunityIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembershipsApi
     */
    public checkMembershipStatusMembershipsCheckUserIdCommunitiesCommunityIdGet(requestParameters: MembershipsApiCheckMembershipStatusMembershipsCheckUserIdCommunitiesCommunityIdGetRequest, options?: RawAxiosRequestConfig) {
        return MembershipsApiFp(this.configuration).checkMembershipStatusMembershipsCheckUserIdCommunitiesCommunityIdGet(requestParameters.userId, requestParameters.communityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get count of community members
     * @summary Get Community Member Count
     * @param {MembershipsApiGetCommunityMemberCountMembershipsCommunitiesCommunityIdCountGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembershipsApi
     */
    public getCommunityMemberCountMembershipsCommunitiesCommunityIdCountGet(requestParameters: MembershipsApiGetCommunityMemberCountMembershipsCommunitiesCommunityIdCountGetRequest, options?: RawAxiosRequestConfig) {
        return MembershipsApiFp(this.configuration).getCommunityMemberCountMembershipsCommunitiesCommunityIdCountGet(requestParameters.communityId, requestParameters.isActive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get members of a community
     * @summary Get Community Members
     * @param {MembershipsApiGetCommunityMembersMembershipsCommunitiesCommunityIdMembersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembershipsApi
     */
    public getCommunityMembersMembershipsCommunitiesCommunityIdMembersGet(requestParameters: MembershipsApiGetCommunityMembersMembershipsCommunitiesCommunityIdMembersGetRequest, options?: RawAxiosRequestConfig) {
        return MembershipsApiFp(this.configuration).getCommunityMembersMembershipsCommunitiesCommunityIdMembersGet(requestParameters.communityId, requestParameters.isActive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get organizers of a community (public endpoint)
     * @summary Get Community Organizers
     * @param {MembershipsApiGetCommunityOrganizersMembershipsCommunitiesCommunityIdOrganizersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembershipsApi
     */
    public getCommunityOrganizersMembershipsCommunitiesCommunityIdOrganizersGet(requestParameters: MembershipsApiGetCommunityOrganizersMembershipsCommunitiesCommunityIdOrganizersGetRequest, options?: RawAxiosRequestConfig) {
        return MembershipsApiFp(this.configuration).getCommunityOrganizersMembershipsCommunitiesCommunityIdOrganizersGet(requestParameters.communityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get count of user\'s memberships
     * @summary Get My Membership Count
     * @param {MembershipsApiGetMyMembershipCountMembershipsCountGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembershipsApi
     */
    public getMyMembershipCountMembershipsCountGet(requestParameters: MembershipsApiGetMyMembershipCountMembershipsCountGetRequest = {}, options?: RawAxiosRequestConfig) {
        return MembershipsApiFp(this.configuration).getMyMembershipCountMembershipsCountGet(requestParameters.isActive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get user\'s memberships
     * @summary Get My Memberships
     * @param {MembershipsApiGetMyMembershipsMembershipsMyMembershipsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembershipsApi
     */
    public getMyMembershipsMembershipsMyMembershipsGet(requestParameters: MembershipsApiGetMyMembershipsMembershipsMyMembershipsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return MembershipsApiFp(this.configuration).getMyMembershipsMembershipsMyMembershipsGet(requestParameters.isActive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Join a community
     * @summary Join Community
     * @param {MembershipsApiJoinCommunityMembershipsJoinPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembershipsApi
     */
    public joinCommunityMembershipsJoinPost(requestParameters: MembershipsApiJoinCommunityMembershipsJoinPostRequest, options?: RawAxiosRequestConfig) {
        return MembershipsApiFp(this.configuration).joinCommunityMembershipsJoinPost(requestParameters.joinCommunityInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Leave a community
     * @summary Leave Community
     * @param {MembershipsApiLeaveCommunityMembershipsLeavePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembershipsApi
     */
    public leaveCommunityMembershipsLeavePost(requestParameters: MembershipsApiLeaveCommunityMembershipsLeavePostRequest, options?: RawAxiosRequestConfig) {
        return MembershipsApiFp(this.configuration).leaveCommunityMembershipsLeavePost(requestParameters.leaveCommunityInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove organizer status from your own membership
     * @summary Remove Own Organizer Status
     * @param {MembershipsApiRemoveOwnOrganizerStatusMembershipsCommunitiesCommunityIdRemoveMyOrganizerStatusPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembershipsApi
     */
    public removeOwnOrganizerStatusMembershipsCommunitiesCommunityIdRemoveMyOrganizerStatusPatch(requestParameters: MembershipsApiRemoveOwnOrganizerStatusMembershipsCommunitiesCommunityIdRemoveMyOrganizerStatusPatchRequest, options?: RawAxiosRequestConfig) {
        return MembershipsApiFp(this.configuration).removeOwnOrganizerStatusMembershipsCommunitiesCommunityIdRemoveMyOrganizerStatusPatch(requestParameters.communityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a member\'s organizer status (requires OWNER or EDITOR role)
     * @summary Update Member Organizer Status
     * @param {MembershipsApiUpdateMemberOrganizerStatusMembershipsCommunitiesCommunityIdMembersUserIdOrganizerStatusPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembershipsApi
     */
    public updateMemberOrganizerStatusMembershipsCommunitiesCommunityIdMembersUserIdOrganizerStatusPatch(requestParameters: MembershipsApiUpdateMemberOrganizerStatusMembershipsCommunitiesCommunityIdMembersUserIdOrganizerStatusPatchRequest, options?: RawAxiosRequestConfig) {
        return MembershipsApiFp(this.configuration).updateMemberOrganizerStatusMembershipsCommunitiesCommunityIdMembersUserIdOrganizerStatusPatch(requestParameters.communityId, requestParameters.userId, requestParameters.updateMemberOrganizerStatusInput, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PeopleApi - axios parameter creator
 * @export
 */
export const PeopleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ADMIN VIEW - create missing people with proper transaction handling
         * @summary Bulk Create People
         * @param {BulkCreatePeopleInput} bulkCreatePeopleInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkCreatePeoplePeopleBulkCreatePost: async (bulkCreatePeopleInput: BulkCreatePeopleInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkCreatePeopleInput' is not null or undefined
            assertParamExists('bulkCreatePeoplePeopleBulkCreatePost', 'bulkCreatePeopleInput', bulkCreatePeopleInput)
            const localVarPath = `/people/bulk_create/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkCreatePeopleInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ADMIN VIEW - bulk existence check with validation and limits
         * @summary Bulk Get People
         * @param {BulkGetPeopleInput} bulkGetPeopleInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetPeoplePeopleBulkGetPost: async (bulkGetPeopleInput: BulkGetPeopleInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkGetPeopleInput' is not null or undefined
            assertParamExists('bulkGetPeoplePeopleBulkGetPost', 'bulkGetPeopleInput', bulkGetPeopleInput)
            const localVarPath = `/people/bulk_get/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkGetPeopleInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Person
         * @param {PersonInput} personInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPersonPeoplePost: async (personInput: PersonInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'personInput' is not null or undefined
            assertParamExists('createPersonPeoplePost', 'personInput', personInput)
            const localVarPath = `/people/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(personInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Person By User Id
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonByUserIdPeopleUserIdGet: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getPersonByUserIdPeopleUserIdGet', 'userId', userId)
            const localVarPath = `/people/{user_id}/`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Relationship Stats
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelationshipStatsPeopleUserIdRelationshipStatsGet: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getRelationshipStatsPeopleUserIdRelationshipStatsGet', 'userId', userId)
            const localVarPath = `/people/{user_id}/relationship/stats/`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Second Degree Connections
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSecondDegreeConnectionsPeopleUserIdSecondDegreeConnectionsGet: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getSecondDegreeConnectionsPeopleUserIdSecondDegreeConnectionsGet', 'userId', userId)
            const localVarPath = `/people/{user_id}/second-degree-connections/`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List All People
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllPeoplePeopleGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/people/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PeopleApi - functional programming interface
 * @export
 */
export const PeopleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PeopleApiAxiosParamCreator(configuration)
    return {
        /**
         * ADMIN VIEW - create missing people with proper transaction handling
         * @summary Bulk Create People
         * @param {BulkCreatePeopleInput} bulkCreatePeopleInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkCreatePeoplePeopleBulkCreatePost(bulkCreatePeopleInput: BulkCreatePeopleInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkCreatePeoplePeopleBulkCreatePost(bulkCreatePeopleInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PeopleApi.bulkCreatePeoplePeopleBulkCreatePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * ADMIN VIEW - bulk existence check with validation and limits
         * @summary Bulk Get People
         * @param {BulkGetPeopleInput} bulkGetPeopleInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkGetPeoplePeopleBulkGetPost(bulkGetPeopleInput: BulkGetPeopleInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Person>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkGetPeoplePeopleBulkGetPost(bulkGetPeopleInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PeopleApi.bulkGetPeoplePeopleBulkGetPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Create Person
         * @param {PersonInput} personInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPersonPeoplePost(personInput: PersonInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Person>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPersonPeoplePost(personInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PeopleApi.createPersonPeoplePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Person By User Id
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPersonByUserIdPeopleUserIdGet(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Person>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPersonByUserIdPeopleUserIdGet(userId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PeopleApi.getPersonByUserIdPeopleUserIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Relationship Stats
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRelationshipStatsPeopleUserIdRelationshipStatsGet(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RelationshipStats>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRelationshipStatsPeopleUserIdRelationshipStatsGet(userId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PeopleApi.getRelationshipStatsPeopleUserIdRelationshipStatsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Second Degree Connections
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSecondDegreeConnectionsPeopleUserIdSecondDegreeConnectionsGet(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Person>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSecondDegreeConnectionsPeopleUserIdSecondDegreeConnectionsGet(userId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PeopleApi.getSecondDegreeConnectionsPeopleUserIdSecondDegreeConnectionsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary List All People
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAllPeoplePeopleGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Person>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAllPeoplePeopleGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PeopleApi.listAllPeoplePeopleGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * PeopleApi - factory interface
 * @export
 */
export const PeopleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PeopleApiFp(configuration)
    return {
        /**
         * ADMIN VIEW - create missing people with proper transaction handling
         * @summary Bulk Create People
         * @param {PeopleApiBulkCreatePeoplePeopleBulkCreatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkCreatePeoplePeopleBulkCreatePost(requestParameters: PeopleApiBulkCreatePeoplePeopleBulkCreatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.bulkCreatePeoplePeopleBulkCreatePost(requestParameters.bulkCreatePeopleInput, options).then((request) => request(axios, basePath));
        },
        /**
         * ADMIN VIEW - bulk existence check with validation and limits
         * @summary Bulk Get People
         * @param {PeopleApiBulkGetPeoplePeopleBulkGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetPeoplePeopleBulkGetPost(requestParameters: PeopleApiBulkGetPeoplePeopleBulkGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Person>> {
            return localVarFp.bulkGetPeoplePeopleBulkGetPost(requestParameters.bulkGetPeopleInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Person
         * @param {PeopleApiCreatePersonPeoplePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPersonPeoplePost(requestParameters: PeopleApiCreatePersonPeoplePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Person> {
            return localVarFp.createPersonPeoplePost(requestParameters.personInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Person By User Id
         * @param {PeopleApiGetPersonByUserIdPeopleUserIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonByUserIdPeopleUserIdGet(requestParameters: PeopleApiGetPersonByUserIdPeopleUserIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Person> {
            return localVarFp.getPersonByUserIdPeopleUserIdGet(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Relationship Stats
         * @param {PeopleApiGetRelationshipStatsPeopleUserIdRelationshipStatsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelationshipStatsPeopleUserIdRelationshipStatsGet(requestParameters: PeopleApiGetRelationshipStatsPeopleUserIdRelationshipStatsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<RelationshipStats> {
            return localVarFp.getRelationshipStatsPeopleUserIdRelationshipStatsGet(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Second Degree Connections
         * @param {PeopleApiGetSecondDegreeConnectionsPeopleUserIdSecondDegreeConnectionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSecondDegreeConnectionsPeopleUserIdSecondDegreeConnectionsGet(requestParameters: PeopleApiGetSecondDegreeConnectionsPeopleUserIdSecondDegreeConnectionsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Person>> {
            return localVarFp.getSecondDegreeConnectionsPeopleUserIdSecondDegreeConnectionsGet(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List All People
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllPeoplePeopleGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<Person>> {
            return localVarFp.listAllPeoplePeopleGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for bulkCreatePeoplePeopleBulkCreatePost operation in PeopleApi.
 * @export
 * @interface PeopleApiBulkCreatePeoplePeopleBulkCreatePostRequest
 */
export interface PeopleApiBulkCreatePeoplePeopleBulkCreatePostRequest {
    /**
     * 
     * @type {BulkCreatePeopleInput}
     * @memberof PeopleApiBulkCreatePeoplePeopleBulkCreatePost
     */
    readonly bulkCreatePeopleInput: BulkCreatePeopleInput
}

/**
 * Request parameters for bulkGetPeoplePeopleBulkGetPost operation in PeopleApi.
 * @export
 * @interface PeopleApiBulkGetPeoplePeopleBulkGetPostRequest
 */
export interface PeopleApiBulkGetPeoplePeopleBulkGetPostRequest {
    /**
     * 
     * @type {BulkGetPeopleInput}
     * @memberof PeopleApiBulkGetPeoplePeopleBulkGetPost
     */
    readonly bulkGetPeopleInput: BulkGetPeopleInput
}

/**
 * Request parameters for createPersonPeoplePost operation in PeopleApi.
 * @export
 * @interface PeopleApiCreatePersonPeoplePostRequest
 */
export interface PeopleApiCreatePersonPeoplePostRequest {
    /**
     * 
     * @type {PersonInput}
     * @memberof PeopleApiCreatePersonPeoplePost
     */
    readonly personInput: PersonInput
}

/**
 * Request parameters for getPersonByUserIdPeopleUserIdGet operation in PeopleApi.
 * @export
 * @interface PeopleApiGetPersonByUserIdPeopleUserIdGetRequest
 */
export interface PeopleApiGetPersonByUserIdPeopleUserIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PeopleApiGetPersonByUserIdPeopleUserIdGet
     */
    readonly userId: string
}

/**
 * Request parameters for getRelationshipStatsPeopleUserIdRelationshipStatsGet operation in PeopleApi.
 * @export
 * @interface PeopleApiGetRelationshipStatsPeopleUserIdRelationshipStatsGetRequest
 */
export interface PeopleApiGetRelationshipStatsPeopleUserIdRelationshipStatsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PeopleApiGetRelationshipStatsPeopleUserIdRelationshipStatsGet
     */
    readonly userId: string
}

/**
 * Request parameters for getSecondDegreeConnectionsPeopleUserIdSecondDegreeConnectionsGet operation in PeopleApi.
 * @export
 * @interface PeopleApiGetSecondDegreeConnectionsPeopleUserIdSecondDegreeConnectionsGetRequest
 */
export interface PeopleApiGetSecondDegreeConnectionsPeopleUserIdSecondDegreeConnectionsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PeopleApiGetSecondDegreeConnectionsPeopleUserIdSecondDegreeConnectionsGet
     */
    readonly userId: string
}

/**
 * PeopleApi - object-oriented interface
 * @export
 * @class PeopleApi
 * @extends {BaseAPI}
 */
export class PeopleApi extends BaseAPI {
    /**
     * ADMIN VIEW - create missing people with proper transaction handling
     * @summary Bulk Create People
     * @param {PeopleApiBulkCreatePeoplePeopleBulkCreatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public bulkCreatePeoplePeopleBulkCreatePost(requestParameters: PeopleApiBulkCreatePeoplePeopleBulkCreatePostRequest, options?: RawAxiosRequestConfig) {
        return PeopleApiFp(this.configuration).bulkCreatePeoplePeopleBulkCreatePost(requestParameters.bulkCreatePeopleInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ADMIN VIEW - bulk existence check with validation and limits
     * @summary Bulk Get People
     * @param {PeopleApiBulkGetPeoplePeopleBulkGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public bulkGetPeoplePeopleBulkGetPost(requestParameters: PeopleApiBulkGetPeoplePeopleBulkGetPostRequest, options?: RawAxiosRequestConfig) {
        return PeopleApiFp(this.configuration).bulkGetPeoplePeopleBulkGetPost(requestParameters.bulkGetPeopleInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Person
     * @param {PeopleApiCreatePersonPeoplePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public createPersonPeoplePost(requestParameters: PeopleApiCreatePersonPeoplePostRequest, options?: RawAxiosRequestConfig) {
        return PeopleApiFp(this.configuration).createPersonPeoplePost(requestParameters.personInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Person By User Id
     * @param {PeopleApiGetPersonByUserIdPeopleUserIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public getPersonByUserIdPeopleUserIdGet(requestParameters: PeopleApiGetPersonByUserIdPeopleUserIdGetRequest, options?: RawAxiosRequestConfig) {
        return PeopleApiFp(this.configuration).getPersonByUserIdPeopleUserIdGet(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Relationship Stats
     * @param {PeopleApiGetRelationshipStatsPeopleUserIdRelationshipStatsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public getRelationshipStatsPeopleUserIdRelationshipStatsGet(requestParameters: PeopleApiGetRelationshipStatsPeopleUserIdRelationshipStatsGetRequest, options?: RawAxiosRequestConfig) {
        return PeopleApiFp(this.configuration).getRelationshipStatsPeopleUserIdRelationshipStatsGet(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Second Degree Connections
     * @param {PeopleApiGetSecondDegreeConnectionsPeopleUserIdSecondDegreeConnectionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public getSecondDegreeConnectionsPeopleUserIdSecondDegreeConnectionsGet(requestParameters: PeopleApiGetSecondDegreeConnectionsPeopleUserIdSecondDegreeConnectionsGetRequest, options?: RawAxiosRequestConfig) {
        return PeopleApiFp(this.configuration).getSecondDegreeConnectionsPeopleUserIdSecondDegreeConnectionsGet(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List All People
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public listAllPeoplePeopleGet(options?: RawAxiosRequestConfig) {
        return PeopleApiFp(this.configuration).listAllPeoplePeopleGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RatingsApi - axios parameter creator
 * @export
 */
export const RatingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Check if current user has rated another user
         * @summary Check If Rated
         * @param {string} ratedUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkIfRatedRatingsIsRatedRatedUserIdGet: async (ratedUserId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ratedUserId' is not null or undefined
            assertParamExists('checkIfRatedRatingsIsRatedRatedUserIdGet', 'ratedUserId', ratedUserId)
            const localVarPath = `/ratings/is-rated/{rated_user_id}/`
                .replace(`{${"rated_user_id"}}`, encodeURIComponent(String(ratedUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get count of ratings received by the current user
         * @summary Get Rating Count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRatingCountRatingsCountGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ratings/count/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all ratings given by a user (admin only or data owner)
         * @summary Get Ratings Given
         * @param {string} userId 
         * @param {string} [eventId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRatingsGivenRatingsUsersUserIdGivenGet: async (userId: string, eventId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getRatingsGivenRatingsUsersUserIdGivenGet', 'userId', userId)
            const localVarPath = `/ratings/users/{user_id}/given/`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (eventId !== undefined) {
                localVarQueryParameter['event_id'] = eventId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all ratings received by a user (admin only or data owner)
         * @summary Get Ratings Received
         * @param {string} userId 
         * @param {string} [eventId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRatingsReceivedRatingsUsersUserIdReceivedGet: async (userId: string, eventId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getRatingsReceivedRatingsUsersUserIdReceivedGet', 'userId', userId)
            const localVarPath = `/ratings/users/{user_id}/received/`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (eventId !== undefined) {
                localVarQueryParameter['event_id'] = eventId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Rate a connection between users
         * @summary Rate Connection
         * @param {RateConnectionInput} rateConnectionInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rateConnectionRatingsPost: async (rateConnectionInput: RateConnectionInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rateConnectionInput' is not null or undefined
            assertParamExists('rateConnectionRatingsPost', 'rateConnectionInput', rateConnectionInput)
            const localVarPath = `/ratings/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rateConnectionInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RatingsApi - functional programming interface
 * @export
 */
export const RatingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RatingsApiAxiosParamCreator(configuration)
    return {
        /**
         * Check if current user has rated another user
         * @summary Check If Rated
         * @param {string} ratedUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkIfRatedRatingsIsRatedRatedUserIdGet(ratedUserId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkIfRatedRatingsIsRatedRatedUserIdGet(ratedUserId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RatingsApi.checkIfRatedRatingsIsRatedRatedUserIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get count of ratings received by the current user
         * @summary Get Rating Count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRatingCountRatingsCountGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RatingCountOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRatingCountRatingsCountGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RatingsApi.getRatingCountRatingsCountGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get all ratings given by a user (admin only or data owner)
         * @summary Get Ratings Given
         * @param {string} userId 
         * @param {string} [eventId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRatingsGivenRatingsUsersUserIdGivenGet(userId: string, eventId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserRatingsOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRatingsGivenRatingsUsersUserIdGivenGet(userId, eventId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RatingsApi.getRatingsGivenRatingsUsersUserIdGivenGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get all ratings received by a user (admin only or data owner)
         * @summary Get Ratings Received
         * @param {string} userId 
         * @param {string} [eventId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRatingsReceivedRatingsUsersUserIdReceivedGet(userId: string, eventId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserRatingsOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRatingsReceivedRatingsUsersUserIdReceivedGet(userId, eventId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RatingsApi.getRatingsReceivedRatingsUsersUserIdReceivedGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Rate a connection between users
         * @summary Rate Connection
         * @param {RateConnectionInput} rateConnectionInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rateConnectionRatingsPost(rateConnectionInput: RateConnectionInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RateConnectionOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rateConnectionRatingsPost(rateConnectionInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RatingsApi.rateConnectionRatingsPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * RatingsApi - factory interface
 * @export
 */
export const RatingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RatingsApiFp(configuration)
    return {
        /**
         * Check if current user has rated another user
         * @summary Check If Rated
         * @param {RatingsApiCheckIfRatedRatingsIsRatedRatedUserIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkIfRatedRatingsIsRatedRatedUserIdGet(requestParameters: RatingsApiCheckIfRatedRatingsIsRatedRatedUserIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.checkIfRatedRatingsIsRatedRatedUserIdGet(requestParameters.ratedUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get count of ratings received by the current user
         * @summary Get Rating Count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRatingCountRatingsCountGet(options?: RawAxiosRequestConfig): AxiosPromise<RatingCountOutput> {
            return localVarFp.getRatingCountRatingsCountGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Get all ratings given by a user (admin only or data owner)
         * @summary Get Ratings Given
         * @param {RatingsApiGetRatingsGivenRatingsUsersUserIdGivenGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRatingsGivenRatingsUsersUserIdGivenGet(requestParameters: RatingsApiGetRatingsGivenRatingsUsersUserIdGivenGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserRatingsOutput> {
            return localVarFp.getRatingsGivenRatingsUsersUserIdGivenGet(requestParameters.userId, requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all ratings received by a user (admin only or data owner)
         * @summary Get Ratings Received
         * @param {RatingsApiGetRatingsReceivedRatingsUsersUserIdReceivedGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRatingsReceivedRatingsUsersUserIdReceivedGet(requestParameters: RatingsApiGetRatingsReceivedRatingsUsersUserIdReceivedGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserRatingsOutput> {
            return localVarFp.getRatingsReceivedRatingsUsersUserIdReceivedGet(requestParameters.userId, requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Rate a connection between users
         * @summary Rate Connection
         * @param {RatingsApiRateConnectionRatingsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rateConnectionRatingsPost(requestParameters: RatingsApiRateConnectionRatingsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<RateConnectionOutput> {
            return localVarFp.rateConnectionRatingsPost(requestParameters.rateConnectionInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for checkIfRatedRatingsIsRatedRatedUserIdGet operation in RatingsApi.
 * @export
 * @interface RatingsApiCheckIfRatedRatingsIsRatedRatedUserIdGetRequest
 */
export interface RatingsApiCheckIfRatedRatingsIsRatedRatedUserIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof RatingsApiCheckIfRatedRatingsIsRatedRatedUserIdGet
     */
    readonly ratedUserId: string
}

/**
 * Request parameters for getRatingsGivenRatingsUsersUserIdGivenGet operation in RatingsApi.
 * @export
 * @interface RatingsApiGetRatingsGivenRatingsUsersUserIdGivenGetRequest
 */
export interface RatingsApiGetRatingsGivenRatingsUsersUserIdGivenGetRequest {
    /**
     * 
     * @type {string}
     * @memberof RatingsApiGetRatingsGivenRatingsUsersUserIdGivenGet
     */
    readonly userId: string

    /**
     * 
     * @type {string}
     * @memberof RatingsApiGetRatingsGivenRatingsUsersUserIdGivenGet
     */
    readonly eventId?: string
}

/**
 * Request parameters for getRatingsReceivedRatingsUsersUserIdReceivedGet operation in RatingsApi.
 * @export
 * @interface RatingsApiGetRatingsReceivedRatingsUsersUserIdReceivedGetRequest
 */
export interface RatingsApiGetRatingsReceivedRatingsUsersUserIdReceivedGetRequest {
    /**
     * 
     * @type {string}
     * @memberof RatingsApiGetRatingsReceivedRatingsUsersUserIdReceivedGet
     */
    readonly userId: string

    /**
     * 
     * @type {string}
     * @memberof RatingsApiGetRatingsReceivedRatingsUsersUserIdReceivedGet
     */
    readonly eventId?: string
}

/**
 * Request parameters for rateConnectionRatingsPost operation in RatingsApi.
 * @export
 * @interface RatingsApiRateConnectionRatingsPostRequest
 */
export interface RatingsApiRateConnectionRatingsPostRequest {
    /**
     * 
     * @type {RateConnectionInput}
     * @memberof RatingsApiRateConnectionRatingsPost
     */
    readonly rateConnectionInput: RateConnectionInput
}

/**
 * RatingsApi - object-oriented interface
 * @export
 * @class RatingsApi
 * @extends {BaseAPI}
 */
export class RatingsApi extends BaseAPI {
    /**
     * Check if current user has rated another user
     * @summary Check If Rated
     * @param {RatingsApiCheckIfRatedRatingsIsRatedRatedUserIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RatingsApi
     */
    public checkIfRatedRatingsIsRatedRatedUserIdGet(requestParameters: RatingsApiCheckIfRatedRatingsIsRatedRatedUserIdGetRequest, options?: RawAxiosRequestConfig) {
        return RatingsApiFp(this.configuration).checkIfRatedRatingsIsRatedRatedUserIdGet(requestParameters.ratedUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get count of ratings received by the current user
     * @summary Get Rating Count
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RatingsApi
     */
    public getRatingCountRatingsCountGet(options?: RawAxiosRequestConfig) {
        return RatingsApiFp(this.configuration).getRatingCountRatingsCountGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all ratings given by a user (admin only or data owner)
     * @summary Get Ratings Given
     * @param {RatingsApiGetRatingsGivenRatingsUsersUserIdGivenGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RatingsApi
     */
    public getRatingsGivenRatingsUsersUserIdGivenGet(requestParameters: RatingsApiGetRatingsGivenRatingsUsersUserIdGivenGetRequest, options?: RawAxiosRequestConfig) {
        return RatingsApiFp(this.configuration).getRatingsGivenRatingsUsersUserIdGivenGet(requestParameters.userId, requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all ratings received by a user (admin only or data owner)
     * @summary Get Ratings Received
     * @param {RatingsApiGetRatingsReceivedRatingsUsersUserIdReceivedGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RatingsApi
     */
    public getRatingsReceivedRatingsUsersUserIdReceivedGet(requestParameters: RatingsApiGetRatingsReceivedRatingsUsersUserIdReceivedGetRequest, options?: RawAxiosRequestConfig) {
        return RatingsApiFp(this.configuration).getRatingsReceivedRatingsUsersUserIdReceivedGet(requestParameters.userId, requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Rate a connection between users
     * @summary Rate Connection
     * @param {RatingsApiRateConnectionRatingsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RatingsApi
     */
    public rateConnectionRatingsPost(requestParameters: RatingsApiRateConnectionRatingsPostRequest, options?: RawAxiosRequestConfig) {
        return RatingsApiFp(this.configuration).rateConnectionRatingsPost(requestParameters.rateConnectionInput, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SubcommunitiesApi - axios parameter creator
 * @export
 */
export const SubcommunitiesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get parent communities for multiple child communities in bulk
         * @summary Bulk Get Parent Communities
         * @param {BulkGetParentCommunitiesInput} bulkGetParentCommunitiesInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetParentCommunitiesSubcommunitiesBulkParentCommunitiesPost: async (bulkGetParentCommunitiesInput: BulkGetParentCommunitiesInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkGetParentCommunitiesInput' is not null or undefined
            assertParamExists('bulkGetParentCommunitiesSubcommunitiesBulkParentCommunitiesPost', 'bulkGetParentCommunitiesInput', bulkGetParentCommunitiesInput)
            const localVarPath = `/subcommunities/bulk-parent-communities/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkGetParentCommunitiesInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check if a community is a subcommunity of another community
         * @summary Check Subcommunity Status
         * @param {string} communityId 
         * @param {string} parentCommunityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkSubcommunityStatusSubcommunitiesCheckChildrenCommunityIdParentsParentCommunityIdGet: async (communityId: string, parentCommunityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('checkSubcommunityStatusSubcommunitiesCheckChildrenCommunityIdParentsParentCommunityIdGet', 'communityId', communityId)
            // verify required parameter 'parentCommunityId' is not null or undefined
            assertParamExists('checkSubcommunityStatusSubcommunitiesCheckChildrenCommunityIdParentsParentCommunityIdGet', 'parentCommunityId', parentCommunityId)
            const localVarPath = `/subcommunities/check/children/{community_id}/parents/{parent_community_id}/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)))
                .replace(`{${"parent_community_id"}}`, encodeURIComponent(String(parentCommunityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a subcommunity relationship
         * @summary Create Subcommunity
         * @param {string} communityId 
         * @param {CreateSubcommunityInput} createSubcommunityInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubcommunitySubcommunitiesCreateCommunityIdPost: async (communityId: string, createSubcommunityInput: CreateSubcommunityInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('createSubcommunitySubcommunitiesCreateCommunityIdPost', 'communityId', communityId)
            // verify required parameter 'createSubcommunityInput' is not null or undefined
            assertParamExists('createSubcommunitySubcommunitiesCreateCommunityIdPost', 'createSubcommunityInput', createSubcommunityInput)
            const localVarPath = `/subcommunities/create/{community_id}/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSubcommunityInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all parent communities of a child community
         * @summary Get Parent Communities
         * @param {string} communityId 
         * @param {boolean} [isActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParentCommunitiesSubcommunitiesParentsCommunityIdGet: async (communityId: string, isActive?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('getParentCommunitiesSubcommunitiesParentsCommunityIdGet', 'communityId', communityId)
            const localVarPath = `/subcommunities/parents/{community_id}/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (isActive !== undefined) {
                localVarQueryParameter['is_active'] = isActive;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get count of parent communities for a child community
         * @summary Get Parent Community Count
         * @param {string} communityId 
         * @param {boolean} [isActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParentCommunityCountSubcommunitiesParentCountCommunityIdGet: async (communityId: string, isActive?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('getParentCommunityCountSubcommunitiesParentCountCommunityIdGet', 'communityId', communityId)
            const localVarPath = `/subcommunities/parent-count/{community_id}/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isActive !== undefined) {
                localVarQueryParameter['is_active'] = isActive;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all subcommunities of a parent community with configurable depth (1-5 levels)
         * @summary Get Subcommunities
         * @param {string} parentCommunityId 
         * @param {boolean} [isActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubcommunitiesSubcommunitiesCommunitiesParentCommunityIdGet: async (parentCommunityId: string, isActive?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'parentCommunityId' is not null or undefined
            assertParamExists('getSubcommunitiesSubcommunitiesCommunitiesParentCommunityIdGet', 'parentCommunityId', parentCommunityId)
            const localVarPath = `/subcommunities/communities/{parent_community_id}/`
                .replace(`{${"parent_community_id"}}`, encodeURIComponent(String(parentCommunityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (isActive !== undefined) {
                localVarQueryParameter['is_active'] = isActive;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get count of subcommunities for a parent community
         * @summary Get Subcommunity Count
         * @param {string} parentCommunityId 
         * @param {boolean} [isActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubcommunityCountSubcommunitiesCountParentCommunityIdGet: async (parentCommunityId: string, isActive?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'parentCommunityId' is not null or undefined
            assertParamExists('getSubcommunityCountSubcommunitiesCountParentCommunityIdGet', 'parentCommunityId', parentCommunityId)
            const localVarPath = `/subcommunities/count/{parent_community_id}/`
                .replace(`{${"parent_community_id"}}`, encodeURIComponent(String(parentCommunityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isActive !== undefined) {
                localVarQueryParameter['is_active'] = isActive;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a child community from a parent community (requires child ownership)
         * @summary Remove Child From Parent
         * @param {string} communityId 
         * @param {string} parentCommunityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeChildFromParentSubcommunitiesRemoveChildrenCommunityIdParentsParentCommunityIdDelete: async (communityId: string, parentCommunityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('removeChildFromParentSubcommunitiesRemoveChildrenCommunityIdParentsParentCommunityIdDelete', 'communityId', communityId)
            // verify required parameter 'parentCommunityId' is not null or undefined
            assertParamExists('removeChildFromParentSubcommunitiesRemoveChildrenCommunityIdParentsParentCommunityIdDelete', 'parentCommunityId', parentCommunityId)
            const localVarPath = `/subcommunities/remove/children/{community_id}/parents/{parent_community_id}/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)))
                .replace(`{${"parent_community_id"}}`, encodeURIComponent(String(parentCommunityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a parent community from a child community (requires child ownership)
         * @summary Remove Parent From Child
         * @param {string} communityId 
         * @param {string} childCommunityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeParentFromChildSubcommunitiesRemoveParentsCommunityIdChildrenChildCommunityIdDelete: async (communityId: string, childCommunityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('removeParentFromChildSubcommunitiesRemoveParentsCommunityIdChildrenChildCommunityIdDelete', 'communityId', communityId)
            // verify required parameter 'childCommunityId' is not null or undefined
            assertParamExists('removeParentFromChildSubcommunitiesRemoveParentsCommunityIdChildrenChildCommunityIdDelete', 'childCommunityId', childCommunityId)
            const localVarPath = `/subcommunities/remove/parents/{community_id}/children/{child_community_id}/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)))
                .replace(`{${"child_community_id"}}`, encodeURIComponent(String(childCommunityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SubcommunitiesApi - functional programming interface
 * @export
 */
export const SubcommunitiesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SubcommunitiesApiAxiosParamCreator(configuration)
    return {
        /**
         * Get parent communities for multiple child communities in bulk
         * @summary Bulk Get Parent Communities
         * @param {BulkGetParentCommunitiesInput} bulkGetParentCommunitiesInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkGetParentCommunitiesSubcommunitiesBulkParentCommunitiesPost(bulkGetParentCommunitiesInput: BulkGetParentCommunitiesInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkGetParentCommunitiesOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkGetParentCommunitiesSubcommunitiesBulkParentCommunitiesPost(bulkGetParentCommunitiesInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SubcommunitiesApi.bulkGetParentCommunitiesSubcommunitiesBulkParentCommunitiesPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Check if a community is a subcommunity of another community
         * @summary Check Subcommunity Status
         * @param {string} communityId 
         * @param {string} parentCommunityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkSubcommunityStatusSubcommunitiesCheckChildrenCommunityIdParentsParentCommunityIdGet(communityId: string, parentCommunityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IsSubcommunityOfOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkSubcommunityStatusSubcommunitiesCheckChildrenCommunityIdParentsParentCommunityIdGet(communityId, parentCommunityId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SubcommunitiesApi.checkSubcommunityStatusSubcommunitiesCheckChildrenCommunityIdParentsParentCommunityIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Create a subcommunity relationship
         * @summary Create Subcommunity
         * @param {string} communityId 
         * @param {CreateSubcommunityInput} createSubcommunityInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSubcommunitySubcommunitiesCreateCommunityIdPost(communityId: string, createSubcommunityInput: CreateSubcommunityInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateSubcommunityOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSubcommunitySubcommunitiesCreateCommunityIdPost(communityId, createSubcommunityInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SubcommunitiesApi.createSubcommunitySubcommunitiesCreateCommunityIdPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get all parent communities of a child community
         * @summary Get Parent Communities
         * @param {string} communityId 
         * @param {boolean} [isActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getParentCommunitiesSubcommunitiesParentsCommunityIdGet(communityId: string, isActive?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ParentCommunityOutput>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getParentCommunitiesSubcommunitiesParentsCommunityIdGet(communityId, isActive, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SubcommunitiesApi.getParentCommunitiesSubcommunitiesParentsCommunityIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get count of parent communities for a child community
         * @summary Get Parent Community Count
         * @param {string} communityId 
         * @param {boolean} [isActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getParentCommunityCountSubcommunitiesParentCountCommunityIdGet(communityId: string, isActive?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubcommunityCountOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getParentCommunityCountSubcommunitiesParentCountCommunityIdGet(communityId, isActive, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SubcommunitiesApi.getParentCommunityCountSubcommunitiesParentCountCommunityIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get all subcommunities of a parent community with configurable depth (1-5 levels)
         * @summary Get Subcommunities
         * @param {string} parentCommunityId 
         * @param {boolean} [isActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubcommunitiesSubcommunitiesCommunitiesParentCommunityIdGet(parentCommunityId: string, isActive?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SubcommunityOutput>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubcommunitiesSubcommunitiesCommunitiesParentCommunityIdGet(parentCommunityId, isActive, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SubcommunitiesApi.getSubcommunitiesSubcommunitiesCommunitiesParentCommunityIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get count of subcommunities for a parent community
         * @summary Get Subcommunity Count
         * @param {string} parentCommunityId 
         * @param {boolean} [isActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubcommunityCountSubcommunitiesCountParentCommunityIdGet(parentCommunityId: string, isActive?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubcommunityCountOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubcommunityCountSubcommunitiesCountParentCommunityIdGet(parentCommunityId, isActive, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SubcommunitiesApi.getSubcommunityCountSubcommunitiesCountParentCommunityIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Remove a child community from a parent community (requires child ownership)
         * @summary Remove Child From Parent
         * @param {string} communityId 
         * @param {string} parentCommunityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeChildFromParentSubcommunitiesRemoveChildrenCommunityIdParentsParentCommunityIdDelete(communityId: string, parentCommunityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RemoveSubcommunityOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeChildFromParentSubcommunitiesRemoveChildrenCommunityIdParentsParentCommunityIdDelete(communityId, parentCommunityId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SubcommunitiesApi.removeChildFromParentSubcommunitiesRemoveChildrenCommunityIdParentsParentCommunityIdDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Remove a parent community from a child community (requires child ownership)
         * @summary Remove Parent From Child
         * @param {string} communityId 
         * @param {string} childCommunityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeParentFromChildSubcommunitiesRemoveParentsCommunityIdChildrenChildCommunityIdDelete(communityId: string, childCommunityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RemoveSubcommunityOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeParentFromChildSubcommunitiesRemoveParentsCommunityIdChildrenChildCommunityIdDelete(communityId, childCommunityId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SubcommunitiesApi.removeParentFromChildSubcommunitiesRemoveParentsCommunityIdChildrenChildCommunityIdDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * SubcommunitiesApi - factory interface
 * @export
 */
export const SubcommunitiesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SubcommunitiesApiFp(configuration)
    return {
        /**
         * Get parent communities for multiple child communities in bulk
         * @summary Bulk Get Parent Communities
         * @param {SubcommunitiesApiBulkGetParentCommunitiesSubcommunitiesBulkParentCommunitiesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetParentCommunitiesSubcommunitiesBulkParentCommunitiesPost(requestParameters: SubcommunitiesApiBulkGetParentCommunitiesSubcommunitiesBulkParentCommunitiesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BulkGetParentCommunitiesOutput> {
            return localVarFp.bulkGetParentCommunitiesSubcommunitiesBulkParentCommunitiesPost(requestParameters.bulkGetParentCommunitiesInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Check if a community is a subcommunity of another community
         * @summary Check Subcommunity Status
         * @param {SubcommunitiesApiCheckSubcommunityStatusSubcommunitiesCheckChildrenCommunityIdParentsParentCommunityIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkSubcommunityStatusSubcommunitiesCheckChildrenCommunityIdParentsParentCommunityIdGet(requestParameters: SubcommunitiesApiCheckSubcommunityStatusSubcommunitiesCheckChildrenCommunityIdParentsParentCommunityIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<IsSubcommunityOfOutput> {
            return localVarFp.checkSubcommunityStatusSubcommunitiesCheckChildrenCommunityIdParentsParentCommunityIdGet(requestParameters.communityId, requestParameters.parentCommunityId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a subcommunity relationship
         * @summary Create Subcommunity
         * @param {SubcommunitiesApiCreateSubcommunitySubcommunitiesCreateCommunityIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubcommunitySubcommunitiesCreateCommunityIdPost(requestParameters: SubcommunitiesApiCreateSubcommunitySubcommunitiesCreateCommunityIdPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateSubcommunityOutput> {
            return localVarFp.createSubcommunitySubcommunitiesCreateCommunityIdPost(requestParameters.communityId, requestParameters.createSubcommunityInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all parent communities of a child community
         * @summary Get Parent Communities
         * @param {SubcommunitiesApiGetParentCommunitiesSubcommunitiesParentsCommunityIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParentCommunitiesSubcommunitiesParentsCommunityIdGet(requestParameters: SubcommunitiesApiGetParentCommunitiesSubcommunitiesParentsCommunityIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ParentCommunityOutput>> {
            return localVarFp.getParentCommunitiesSubcommunitiesParentsCommunityIdGet(requestParameters.communityId, requestParameters.isActive, options).then((request) => request(axios, basePath));
        },
        /**
         * Get count of parent communities for a child community
         * @summary Get Parent Community Count
         * @param {SubcommunitiesApiGetParentCommunityCountSubcommunitiesParentCountCommunityIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParentCommunityCountSubcommunitiesParentCountCommunityIdGet(requestParameters: SubcommunitiesApiGetParentCommunityCountSubcommunitiesParentCountCommunityIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubcommunityCountOutput> {
            return localVarFp.getParentCommunityCountSubcommunitiesParentCountCommunityIdGet(requestParameters.communityId, requestParameters.isActive, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all subcommunities of a parent community with configurable depth (1-5 levels)
         * @summary Get Subcommunities
         * @param {SubcommunitiesApiGetSubcommunitiesSubcommunitiesCommunitiesParentCommunityIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubcommunitiesSubcommunitiesCommunitiesParentCommunityIdGet(requestParameters: SubcommunitiesApiGetSubcommunitiesSubcommunitiesCommunitiesParentCommunityIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<SubcommunityOutput>> {
            return localVarFp.getSubcommunitiesSubcommunitiesCommunitiesParentCommunityIdGet(requestParameters.parentCommunityId, requestParameters.isActive, options).then((request) => request(axios, basePath));
        },
        /**
         * Get count of subcommunities for a parent community
         * @summary Get Subcommunity Count
         * @param {SubcommunitiesApiGetSubcommunityCountSubcommunitiesCountParentCommunityIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubcommunityCountSubcommunitiesCountParentCommunityIdGet(requestParameters: SubcommunitiesApiGetSubcommunityCountSubcommunitiesCountParentCommunityIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubcommunityCountOutput> {
            return localVarFp.getSubcommunityCountSubcommunitiesCountParentCommunityIdGet(requestParameters.parentCommunityId, requestParameters.isActive, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove a child community from a parent community (requires child ownership)
         * @summary Remove Child From Parent
         * @param {SubcommunitiesApiRemoveChildFromParentSubcommunitiesRemoveChildrenCommunityIdParentsParentCommunityIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeChildFromParentSubcommunitiesRemoveChildrenCommunityIdParentsParentCommunityIdDelete(requestParameters: SubcommunitiesApiRemoveChildFromParentSubcommunitiesRemoveChildrenCommunityIdParentsParentCommunityIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<RemoveSubcommunityOutput> {
            return localVarFp.removeChildFromParentSubcommunitiesRemoveChildrenCommunityIdParentsParentCommunityIdDelete(requestParameters.communityId, requestParameters.parentCommunityId, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove a parent community from a child community (requires child ownership)
         * @summary Remove Parent From Child
         * @param {SubcommunitiesApiRemoveParentFromChildSubcommunitiesRemoveParentsCommunityIdChildrenChildCommunityIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeParentFromChildSubcommunitiesRemoveParentsCommunityIdChildrenChildCommunityIdDelete(requestParameters: SubcommunitiesApiRemoveParentFromChildSubcommunitiesRemoveParentsCommunityIdChildrenChildCommunityIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<RemoveSubcommunityOutput> {
            return localVarFp.removeParentFromChildSubcommunitiesRemoveParentsCommunityIdChildrenChildCommunityIdDelete(requestParameters.communityId, requestParameters.childCommunityId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for bulkGetParentCommunitiesSubcommunitiesBulkParentCommunitiesPost operation in SubcommunitiesApi.
 * @export
 * @interface SubcommunitiesApiBulkGetParentCommunitiesSubcommunitiesBulkParentCommunitiesPostRequest
 */
export interface SubcommunitiesApiBulkGetParentCommunitiesSubcommunitiesBulkParentCommunitiesPostRequest {
    /**
     * 
     * @type {BulkGetParentCommunitiesInput}
     * @memberof SubcommunitiesApiBulkGetParentCommunitiesSubcommunitiesBulkParentCommunitiesPost
     */
    readonly bulkGetParentCommunitiesInput: BulkGetParentCommunitiesInput
}

/**
 * Request parameters for checkSubcommunityStatusSubcommunitiesCheckChildrenCommunityIdParentsParentCommunityIdGet operation in SubcommunitiesApi.
 * @export
 * @interface SubcommunitiesApiCheckSubcommunityStatusSubcommunitiesCheckChildrenCommunityIdParentsParentCommunityIdGetRequest
 */
export interface SubcommunitiesApiCheckSubcommunityStatusSubcommunitiesCheckChildrenCommunityIdParentsParentCommunityIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SubcommunitiesApiCheckSubcommunityStatusSubcommunitiesCheckChildrenCommunityIdParentsParentCommunityIdGet
     */
    readonly communityId: string

    /**
     * 
     * @type {string}
     * @memberof SubcommunitiesApiCheckSubcommunityStatusSubcommunitiesCheckChildrenCommunityIdParentsParentCommunityIdGet
     */
    readonly parentCommunityId: string
}

/**
 * Request parameters for createSubcommunitySubcommunitiesCreateCommunityIdPost operation in SubcommunitiesApi.
 * @export
 * @interface SubcommunitiesApiCreateSubcommunitySubcommunitiesCreateCommunityIdPostRequest
 */
export interface SubcommunitiesApiCreateSubcommunitySubcommunitiesCreateCommunityIdPostRequest {
    /**
     * 
     * @type {string}
     * @memberof SubcommunitiesApiCreateSubcommunitySubcommunitiesCreateCommunityIdPost
     */
    readonly communityId: string

    /**
     * 
     * @type {CreateSubcommunityInput}
     * @memberof SubcommunitiesApiCreateSubcommunitySubcommunitiesCreateCommunityIdPost
     */
    readonly createSubcommunityInput: CreateSubcommunityInput
}

/**
 * Request parameters for getParentCommunitiesSubcommunitiesParentsCommunityIdGet operation in SubcommunitiesApi.
 * @export
 * @interface SubcommunitiesApiGetParentCommunitiesSubcommunitiesParentsCommunityIdGetRequest
 */
export interface SubcommunitiesApiGetParentCommunitiesSubcommunitiesParentsCommunityIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SubcommunitiesApiGetParentCommunitiesSubcommunitiesParentsCommunityIdGet
     */
    readonly communityId: string

    /**
     * 
     * @type {boolean}
     * @memberof SubcommunitiesApiGetParentCommunitiesSubcommunitiesParentsCommunityIdGet
     */
    readonly isActive?: boolean
}

/**
 * Request parameters for getParentCommunityCountSubcommunitiesParentCountCommunityIdGet operation in SubcommunitiesApi.
 * @export
 * @interface SubcommunitiesApiGetParentCommunityCountSubcommunitiesParentCountCommunityIdGetRequest
 */
export interface SubcommunitiesApiGetParentCommunityCountSubcommunitiesParentCountCommunityIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SubcommunitiesApiGetParentCommunityCountSubcommunitiesParentCountCommunityIdGet
     */
    readonly communityId: string

    /**
     * 
     * @type {boolean}
     * @memberof SubcommunitiesApiGetParentCommunityCountSubcommunitiesParentCountCommunityIdGet
     */
    readonly isActive?: boolean
}

/**
 * Request parameters for getSubcommunitiesSubcommunitiesCommunitiesParentCommunityIdGet operation in SubcommunitiesApi.
 * @export
 * @interface SubcommunitiesApiGetSubcommunitiesSubcommunitiesCommunitiesParentCommunityIdGetRequest
 */
export interface SubcommunitiesApiGetSubcommunitiesSubcommunitiesCommunitiesParentCommunityIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SubcommunitiesApiGetSubcommunitiesSubcommunitiesCommunitiesParentCommunityIdGet
     */
    readonly parentCommunityId: string

    /**
     * 
     * @type {boolean}
     * @memberof SubcommunitiesApiGetSubcommunitiesSubcommunitiesCommunitiesParentCommunityIdGet
     */
    readonly isActive?: boolean
}

/**
 * Request parameters for getSubcommunityCountSubcommunitiesCountParentCommunityIdGet operation in SubcommunitiesApi.
 * @export
 * @interface SubcommunitiesApiGetSubcommunityCountSubcommunitiesCountParentCommunityIdGetRequest
 */
export interface SubcommunitiesApiGetSubcommunityCountSubcommunitiesCountParentCommunityIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SubcommunitiesApiGetSubcommunityCountSubcommunitiesCountParentCommunityIdGet
     */
    readonly parentCommunityId: string

    /**
     * 
     * @type {boolean}
     * @memberof SubcommunitiesApiGetSubcommunityCountSubcommunitiesCountParentCommunityIdGet
     */
    readonly isActive?: boolean
}

/**
 * Request parameters for removeChildFromParentSubcommunitiesRemoveChildrenCommunityIdParentsParentCommunityIdDelete operation in SubcommunitiesApi.
 * @export
 * @interface SubcommunitiesApiRemoveChildFromParentSubcommunitiesRemoveChildrenCommunityIdParentsParentCommunityIdDeleteRequest
 */
export interface SubcommunitiesApiRemoveChildFromParentSubcommunitiesRemoveChildrenCommunityIdParentsParentCommunityIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof SubcommunitiesApiRemoveChildFromParentSubcommunitiesRemoveChildrenCommunityIdParentsParentCommunityIdDelete
     */
    readonly communityId: string

    /**
     * 
     * @type {string}
     * @memberof SubcommunitiesApiRemoveChildFromParentSubcommunitiesRemoveChildrenCommunityIdParentsParentCommunityIdDelete
     */
    readonly parentCommunityId: string
}

/**
 * Request parameters for removeParentFromChildSubcommunitiesRemoveParentsCommunityIdChildrenChildCommunityIdDelete operation in SubcommunitiesApi.
 * @export
 * @interface SubcommunitiesApiRemoveParentFromChildSubcommunitiesRemoveParentsCommunityIdChildrenChildCommunityIdDeleteRequest
 */
export interface SubcommunitiesApiRemoveParentFromChildSubcommunitiesRemoveParentsCommunityIdChildrenChildCommunityIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof SubcommunitiesApiRemoveParentFromChildSubcommunitiesRemoveParentsCommunityIdChildrenChildCommunityIdDelete
     */
    readonly communityId: string

    /**
     * 
     * @type {string}
     * @memberof SubcommunitiesApiRemoveParentFromChildSubcommunitiesRemoveParentsCommunityIdChildrenChildCommunityIdDelete
     */
    readonly childCommunityId: string
}

/**
 * SubcommunitiesApi - object-oriented interface
 * @export
 * @class SubcommunitiesApi
 * @extends {BaseAPI}
 */
export class SubcommunitiesApi extends BaseAPI {
    /**
     * Get parent communities for multiple child communities in bulk
     * @summary Bulk Get Parent Communities
     * @param {SubcommunitiesApiBulkGetParentCommunitiesSubcommunitiesBulkParentCommunitiesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubcommunitiesApi
     */
    public bulkGetParentCommunitiesSubcommunitiesBulkParentCommunitiesPost(requestParameters: SubcommunitiesApiBulkGetParentCommunitiesSubcommunitiesBulkParentCommunitiesPostRequest, options?: RawAxiosRequestConfig) {
        return SubcommunitiesApiFp(this.configuration).bulkGetParentCommunitiesSubcommunitiesBulkParentCommunitiesPost(requestParameters.bulkGetParentCommunitiesInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Check if a community is a subcommunity of another community
     * @summary Check Subcommunity Status
     * @param {SubcommunitiesApiCheckSubcommunityStatusSubcommunitiesCheckChildrenCommunityIdParentsParentCommunityIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubcommunitiesApi
     */
    public checkSubcommunityStatusSubcommunitiesCheckChildrenCommunityIdParentsParentCommunityIdGet(requestParameters: SubcommunitiesApiCheckSubcommunityStatusSubcommunitiesCheckChildrenCommunityIdParentsParentCommunityIdGetRequest, options?: RawAxiosRequestConfig) {
        return SubcommunitiesApiFp(this.configuration).checkSubcommunityStatusSubcommunitiesCheckChildrenCommunityIdParentsParentCommunityIdGet(requestParameters.communityId, requestParameters.parentCommunityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a subcommunity relationship
     * @summary Create Subcommunity
     * @param {SubcommunitiesApiCreateSubcommunitySubcommunitiesCreateCommunityIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubcommunitiesApi
     */
    public createSubcommunitySubcommunitiesCreateCommunityIdPost(requestParameters: SubcommunitiesApiCreateSubcommunitySubcommunitiesCreateCommunityIdPostRequest, options?: RawAxiosRequestConfig) {
        return SubcommunitiesApiFp(this.configuration).createSubcommunitySubcommunitiesCreateCommunityIdPost(requestParameters.communityId, requestParameters.createSubcommunityInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all parent communities of a child community
     * @summary Get Parent Communities
     * @param {SubcommunitiesApiGetParentCommunitiesSubcommunitiesParentsCommunityIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubcommunitiesApi
     */
    public getParentCommunitiesSubcommunitiesParentsCommunityIdGet(requestParameters: SubcommunitiesApiGetParentCommunitiesSubcommunitiesParentsCommunityIdGetRequest, options?: RawAxiosRequestConfig) {
        return SubcommunitiesApiFp(this.configuration).getParentCommunitiesSubcommunitiesParentsCommunityIdGet(requestParameters.communityId, requestParameters.isActive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get count of parent communities for a child community
     * @summary Get Parent Community Count
     * @param {SubcommunitiesApiGetParentCommunityCountSubcommunitiesParentCountCommunityIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubcommunitiesApi
     */
    public getParentCommunityCountSubcommunitiesParentCountCommunityIdGet(requestParameters: SubcommunitiesApiGetParentCommunityCountSubcommunitiesParentCountCommunityIdGetRequest, options?: RawAxiosRequestConfig) {
        return SubcommunitiesApiFp(this.configuration).getParentCommunityCountSubcommunitiesParentCountCommunityIdGet(requestParameters.communityId, requestParameters.isActive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all subcommunities of a parent community with configurable depth (1-5 levels)
     * @summary Get Subcommunities
     * @param {SubcommunitiesApiGetSubcommunitiesSubcommunitiesCommunitiesParentCommunityIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubcommunitiesApi
     */
    public getSubcommunitiesSubcommunitiesCommunitiesParentCommunityIdGet(requestParameters: SubcommunitiesApiGetSubcommunitiesSubcommunitiesCommunitiesParentCommunityIdGetRequest, options?: RawAxiosRequestConfig) {
        return SubcommunitiesApiFp(this.configuration).getSubcommunitiesSubcommunitiesCommunitiesParentCommunityIdGet(requestParameters.parentCommunityId, requestParameters.isActive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get count of subcommunities for a parent community
     * @summary Get Subcommunity Count
     * @param {SubcommunitiesApiGetSubcommunityCountSubcommunitiesCountParentCommunityIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubcommunitiesApi
     */
    public getSubcommunityCountSubcommunitiesCountParentCommunityIdGet(requestParameters: SubcommunitiesApiGetSubcommunityCountSubcommunitiesCountParentCommunityIdGetRequest, options?: RawAxiosRequestConfig) {
        return SubcommunitiesApiFp(this.configuration).getSubcommunityCountSubcommunitiesCountParentCommunityIdGet(requestParameters.parentCommunityId, requestParameters.isActive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove a child community from a parent community (requires child ownership)
     * @summary Remove Child From Parent
     * @param {SubcommunitiesApiRemoveChildFromParentSubcommunitiesRemoveChildrenCommunityIdParentsParentCommunityIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubcommunitiesApi
     */
    public removeChildFromParentSubcommunitiesRemoveChildrenCommunityIdParentsParentCommunityIdDelete(requestParameters: SubcommunitiesApiRemoveChildFromParentSubcommunitiesRemoveChildrenCommunityIdParentsParentCommunityIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return SubcommunitiesApiFp(this.configuration).removeChildFromParentSubcommunitiesRemoveChildrenCommunityIdParentsParentCommunityIdDelete(requestParameters.communityId, requestParameters.parentCommunityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove a parent community from a child community (requires child ownership)
     * @summary Remove Parent From Child
     * @param {SubcommunitiesApiRemoveParentFromChildSubcommunitiesRemoveParentsCommunityIdChildrenChildCommunityIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubcommunitiesApi
     */
    public removeParentFromChildSubcommunitiesRemoveParentsCommunityIdChildrenChildCommunityIdDelete(requestParameters: SubcommunitiesApiRemoveParentFromChildSubcommunitiesRemoveParentsCommunityIdChildrenChildCommunityIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return SubcommunitiesApiFp(this.configuration).removeParentFromChildSubcommunitiesRemoveParentsCommunityIdChildrenChildCommunityIdDelete(requestParameters.communityId, requestParameters.childCommunityId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SystemApi - axios parameter creator
 * @export
 */
export const SystemApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Health check endpoint for AWS load balancers and monitoring
         * @summary Health Check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckHealthGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SystemApi - functional programming interface
 * @export
 */
export const SystemApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SystemApiAxiosParamCreator(configuration)
    return {
        /**
         * Health check endpoint for AWS load balancers and monitoring
         * @summary Health Check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthCheckHealthGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthCheckHealthGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SystemApi.healthCheckHealthGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * SystemApi - factory interface
 * @export
 */
export const SystemApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SystemApiFp(configuration)
    return {
        /**
         * Health check endpoint for AWS load balancers and monitoring
         * @summary Health Check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckHealthGet(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.healthCheckHealthGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SystemApi - object-oriented interface
 * @export
 * @class SystemApi
 * @extends {BaseAPI}
 */
export class SystemApi extends BaseAPI {
    /**
     * Health check endpoint for AWS load balancers and monitoring
     * @summary Health Check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public healthCheckHealthGet(options?: RawAxiosRequestConfig) {
        return SystemApiFp(this.configuration).healthCheckHealthGet(options).then((request) => request(this.axios, this.basePath));
    }
}



